// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-23T17:56:58.276Z
// Property: The Lex (ID: 6767906449164272)
// Collections: 13 amenities, 46 floorplans (live), 51 photos, 40 POIs, 3 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162415",
  "multihub_property_id": "6767906449164272",
  "property_external_id": "1550029",
  "property_zillow_url": "https://www.zillow.com/apartments/tacoma-wa/the-lex/CkBTNM/",
  "property_apartments_url": "https://www.apartments.com/755-st-helens-ave-tacoma-wa/gmg8hsx/",
  "property_google_business_url": "https://www.google.com/maps?cid=15842911435948625689",
  "property_linkedin_url": null,
  "property_hubspot_id": "6003821862",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-lex",
  "property_name": "The Lex",
  "property_website_url": "https://www.thelextacoma.com",
  "property_domain": "https://www.thelextacoma.com/",
  "property_address": "415 St Helens Ave",
  "property_full_address": "415 St Helens Ave, Tacoma, WA 98402",
  "property_address_1": "415 St Helens Ave",
  "property_address_2": null,
  "property_address_city": "Tacoma",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98402",
  "property_address_country": "US",
  "property_address_county": "Pierce County",
  "property_neighborhood_address": "Downtown Tacoma",
  "property_address_latitude": "47.26003009999999",
  "property_address_longitude": "-122.4438041",
  "property_email": "info@thelextacoma.com",
  "property_phone": "(253) 353-7523",
  "property_call_tracking_phone": "844-243-5680",
  "property_company_name": "Pillar Properties",
  "property_company_url": "https://www.pillarproperties.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Lex in vibrant Tacoma, where modern living meets luxury. Choose from stylish studio, one-bedroom, or two-bedroom layouts featuring elegant quartz counters and soft-close cabinets. Enjoy breathtaking views from our sky lounge. Your perfect home awaits—browse our availability or schedule a tour today!",
  "property_long_description": "Tacoma is the place to be, and The Lex is perfectly situated - close to the Sounder Transit Station, shopping, dining, and entertainment. Easy commute to downtown Seattle and close to Joint Base Lewis-McChord, MultiCare Health System Tacoma, and the University of Washington Tacoma.Catch sweeping views of Commencement Bay from almost every apartment home at The Lex, if that's still not enough, take it all in from the expansive rooftop deck.Featuring a Walk Score of 96, The Lex is a walker's paradise - an easy stroll to a variety of restaurants and retail.The spacious apartments at The Lex feature high end finishes, tall ceilings, large kitchens and bathrooms, private patios along with resident lounges, huge fitness center, and a rooftop pup park.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
  "property_featured_image_media": {
    "alt_text": "Modern apartment buildings with a view of the water and mountains.",
    "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
    "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
    "width": 2600,
    "height": 1830
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "247",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.3076923076923",
  "property_admin_fee": null,
  "property_application_fee": "45",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "55",
  "property_pet_deposit": "375",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "180",
  "property_pet_restrictions": "Cats and dogs are welcome. Maximum 2 pets per unit.",
  "property_pet_policy_description": "We are a Pet Friendly Community and allow 2 pets and no weight limit.  Pet Fee is $350.00 per pet and one time Pet Deposit is $300.00 with $45.00 per pet Pet Rent.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://thelextacoma.securecafe.com/onlineleasing/the-lex/floorplans.aspx",
  "property_resident_portal_url": "https://thelextacoma.securecafenet.com/residentservices/the-lex/userlogin",
  "property_apply_now_url": "https://thelextacoma.securecafe.com/onlineleasing/the-lex/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019db20d-b104-739a-b5a4-4686c1822e15.webp",
  "property_primary_logo_media": {
    "alt_text": "Logo with the words 'X' and 'THE' and a house icon.",
    "public_id": "019db20d-b104-739a-b5a4-4686c1822e15",
    "storage_key": "property/6767906449164272/019db20d-b104-739a-b5a4-4686c1822e15.webp",
    "width": 1140,
    "height": 3072
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d6dec-033c-72d8-be50-a57ff51bcbd7.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Lex logo",
    "public_id": "019d6dec-033c-72d8-be50-a57ff51bcbd7",
    "storage_key": "property/6767906449164272/019d6dec-033c-72d8-be50-a57ff51bcbd7.webp",
    "width": 2048,
    "height": 2048
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019db20d-ab30-7508-b3ca-a9164b691e88.webp",
  "property_icon_media": {
    "alt_text": "The Lex logo",
    "public_id": "019db20d-ab30-7508-b3ca-a9164b691e88",
    "storage_key": "property/6767906449164272/019db20d-ab30-7508-b3ca-a9164b691e88.webp",
    "width": 3072,
    "height": 3072
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019db20d-c5fe-74c9-9e46-594189b77fe3.webp",
  "property_fav_icon_media": {
    "alt_text": "The Lex Logo",
    "public_id": "019db20d-c5fe-74c9-9e46-594189b77fe3",
    "storage_key": "property/6767906449164272/019db20d-c5fe-74c9-9e46-594189b77fe3.webp",
    "width": 973,
    "height": 972
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0816-4ea2-75ef-a61d-4933d5fc6e0b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Logo for The X Home",
    "public_id": "019d0816-4ea2-75ef-a61d-4933d5fc6e0b",
    "storage_key": "property/6767906449164272/019d0816-4ea2-75ef-a61d-4933d5fc6e0b.webp",
    "width": 100,
    "height": 270
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0816-571c-776b-9e49-8abdded057ec.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Logo with a stylized house and X shape.",
    "public_id": "019d0816-571c-776b-9e49-8abdded057ec",
    "storage_key": "property/6767906449164272/019d0816-571c-776b-9e49-8abdded057ec.webp",
    "width": 100,
    "height": 270
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d06cf-26f9-7551-948c-1245b11c8422.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
  "property_company_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc2-1eb8-7554-8d89-d3424651cf63",
    "storage_key": "company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
    "width": 189,
    "height": 128
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-9029-7028-b531-c3ae9dacde22",
    "storage_key": "company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
    "width": 178,
    "height": 122
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-00d2-7093-a184-b3de0f0bba5a",
    "storage_key": "company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
    "width": 178,
    "height": 122
  },
  "property_primary_color": "#2f6067",
  "property_secondary_color": "#1e2848",
  "property_font_color": "#1E2848",
  "property_color_4": "#f9f9df",
  "property_color_3": "#b8d637",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "543 - 1316",
  "property_sqft_min": "543",
  "property_sqft_max": "1316",
  "property_price_range": "1564 - 3959",
  "property_price_min": "1564",
  "property_price_max": "3959",
  "property_available_units": 22,
  "property_facebook_url": "https://www.facebook.com/100088635252017",
  "property_instagram_url": "https://www.instagram.com/thelextacoma",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ0emzv2NVkFQRGQ-x-wJU3ds",
  "property_youtube_url": "https://www.youtube.com/watch?t=199&v=uOybJ4XvmGQ",
  "property_yelp_url": "https://www.yelp.com/biz/the-lex-tacoma",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Lex",
  "property_home_romance_title": "Embrace a New Chapter in Your Perfect Apartment Community",
  "property_home_amenities_blurb": "Welcome to The Lex in Tacoma, where modern living meets comfort. Delight in our stylish studio, one-bedroom, and two-bedroom floor plans, each adorned with quartz counters and soft close cabinets. Unwind in our stunning sky lounge, perfect for enjoying breathtaking views and vibrant community moments. Experience your ideal home today!",
  "property_home_floorplans_blurb": "Welcome to The Lex in Tacoma, where modern living meets thoughtful design. Our diverse floor plans range from cozy studios to spacious two-bedroom apartments, tailored to fit your lifestyle. Dive into our offerings and envision your ideal home—your perfect space awaits amidst the vibrant Tacoma community.",
  "property_home_gallery_blurb": "At The Lex in Tacoma, each thoughtfully designed floor plan—studio, one-bedroom, or two-bedroom—offers modern elegance with quartz counters and soft-close cabinets. Unwind in our stunning sky lounge and imagine the vibrant community waiting for you. Picture yourself living here—your perfect home awaits!",
  "property_home_neighborhood_blurb": "Welcome to The Lex, where urban living meets vibrant community life in Tacoma! Choose from cozy studios to spacious two-bedroom apartments. Enjoy proximity to cultural gems like the Museum of Glass, Point Defiance Zoo & Aquarium, and Tacoma Community College, ensuring your lifestyle is as inspiring as your surroundings. ",
  "property_home_reviews_blurb": "At The Lex in Tacoma, our residents rave about the vibrant community spirit and exceptional service. One resident shares, \"I love the sense of community they build with their monthly events.\" Enjoy incredible amenities, friendly staff, and the best views from our rooftop. Experience the warmth of The Lex today!",
  "property_neighborhood_blurb": "At The Lex in Tacoma, your lifestyle is enriched by vibrant nearby attractions. Embrace nature at Point Defiance Park and enjoy the arts at the Museum of Glass. With Tacoma Community College and the University of Puget Sound just minutes away, education is at your doorstep. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Lex in Tacoma, luxury meets comfort with inviting studio, one-bedroom, and two-bedroom floor plans. Enjoy stunning quartz counters, soft-close cabinets, and unwind in our exclusive Sky Lounge. Experience a lifestyle tailored to you in a vibrant community that feels like home. Join us today!",
  "property_applynow_blurb": "At The Lex in Tacoma, your ideal living space awaits! Choose from stylish studio, one-bedroom, and two-bedroom floor plans, each featuring elegant quartz counters and soft-close cabinets. Enjoy breathtaking views from our sky lounge. Embrace comfortable living—secure your new home and lease online today!",
  "property_contactus_blurb": "At The Lex in Tacoma, find the perfect home tailored to your lifestyle with our diverse floor plans, including stylish studios, spacious one-bedrooms, and inviting two-bedroom units. Ready to learn more about your future sanctuary? Our leasing team is just a message away—connect with us today!",
  "property_faqs_blurb": "At The Lex in Tacoma, we offer a range of floor plans to suit your lifestyle, from cozy studios to spacious two-bedroom apartments. Got questions? Our FAQs page provides insight into community living, amenities, and more. Dive in and uncover the details that make The Lex your ideal home!",
  "property_floorplans_blurb": "At The Lex in Tacoma, we offer an array of thoughtfully designed floor plans, from cozy studios to spacious two-bedroom apartments. Each home blends modern comfort with stylish finishes, perfectly tailored to your lifestyle. Browse our unique options and find the ideal space that feels just right for you.",
  "property_gallery_blurb": "At The Lex in Tacoma, picture yourself enjoying luxurious living with stunning floor plans, from cozy studios to spacious two-bedroom layouts. Indulge in upscale amenities like a chic sky lounge and modern quartz counters that elevate your everyday life. Your dream apartment awaits—let the photo gallery inspire your next move!",
  "property_interactivemap_blurb": "At The Lex in Tacoma, find your perfect home among our thoughtfully designed studio, one-bedroom, and two-bedroom apartments. Enjoy modern living with quartz counters, soft-close cabinets, and a stunning sky lounge. Use our interactive community map to explore available apartments and see for yourself what makes The Lex unique!",
  "property_pets_blurb": "At The Lex in Tacoma, your furry friends are more than welcome! With a pet-friendly policy that embraces both cats and dogs, you can enjoy life in a vibrant community without leaving your pets behind. Enjoy ample green spaces and convenient access to outdoor adventures just outside your door!",
  "property_referafriend_blurb": "At The Lex in Tacoma, where comfort meets style, our diverse floor plans—studio, one bedroom, and two bedroom—offer the perfect space for everyone. Great friends make great neighbors, so refer a friend and share the vibrant lifestyle our community has to offer today!",
  "property_residentaccess_blurb": "Welcome to The Lex in vibrant Tacoma, where modern living meets convenience. Choose from stylish studio, one-bedroom, or two-bedroom floor plans tailored to your lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and enjoy a seamless living experience at The Lex—your urban sanctuary awaits!",
  "property_reviews_blurb": "At The Lex in Tacoma, residents rave about our incredible sense of community and exceptional service. With rave reviews highlighting our \"friendly staff\" and luxurious amenities like a stunning rooftop, it's no wonder so many choose to call us home. Join us and experience these joys for yourself!",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "At The Lex in Tacoma, choose from stylish studio, one, or two-bedroom floor plans designed for comfort and convenience. Experience vibrant community living that resonates with your lifestyle. Ready to envision your new home? Schedule a tour and see what our residents love about calling The Lex their own!",
  "property_thankyou_blurb": "Thank you for reaching out about The Lex in beautiful Tacoma! With versatile floor plans ranging from cozy studios to spacious two-bedroom apartments, there's a perfect space waiting just for you. Our team will connect soon to help you find your ideal home in our vibrant community!",
  "property_virtualtours_blurb": "Step into modern living at The Lex in Tacoma, where stylish studio, one-bedroom, and two-bedroom apartments await. Each thoughtfully designed floor plan complements your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and find the perfect space that resonates with you!",
  "property_copyright": "2025 All Rights Reserved. The Lex",
  "property_seo_title_home": "Apartments in Downtown Tacoma, WA | The Lex",
  "property_seo_description_home": "The Lex is a luxury apartment living community with studio, 1 & 2-Bedroom apartments for rent in Downtown Tacoma, WA! Contact us today!",
  "property_seo_title_floorplans": "Floor Plans | Luxury Studio, 1-2 Bedroom Apts in Tacoma, WA",
  "property_seo_description_floorplans": "Explore studio, 1 & 2 bedroom luxury apartments at The Lex in WA. Private balconies, stainless-steel appliances, and large walk-in closets await.",
  "property_seo_title_amenities": "Amenities | Downtown Tacoma, WA Apartments With Pet Spa",
  "property_seo_description_amenities": "Enjoy furnished apartments and bike storage at The Lex in Tacoma, WA. Pet-friendly living made easy.",
  "property_seo_title_gallery": "Gallery |  Luxury Apartments For Rent in Downtown Tacoma, WA",
  "property_seo_description_gallery": "View photos of The Lex inTacoma, WA. See stylish floor plans, modern amenities, and pet-friendly community spaces.",
  "property_seo_title_virtualtours": "Virtual Tour | Pet-Friendly Apartments in Tacoma, WA",
  "property_seo_description_virtualtours": "Embark on a virtual journey at The Lex! Explore our pet-friendly studio, 1 & 2 bedroom apts in Tacoma through our virtual tours.",
  "property_seo_title_interactivemap": "Interactive Map | The Lex Apartments",
  "property_seo_description_interactivemap": "Uncover your ideal home at The Lex in Tacoma! Use our interactive map to find studios, 1- & 2-bedroom apartments with luxurious amenities like a Sky Lounge.",
  "property_seo_title_neighborhood": "Neighborhood | Apts For Rent Near Sounder Transit Station",
  "property_seo_description_neighborhood": "Live close to Sounder Transit Station and the University of Washington Tacoma. Spacious WA apartments designed for your comfort & convenience.",
  "property_seo_title_contact": "Contact Us | Apartments For Rent Near Wright Park",
  "property_seo_description_contact": "Contact The Lex today to schedule a tour. Discover studio, one and two bedroom apartments with luxury features in Tacoma, WA.",
  "property_seo_title_faqs": "FAQs | Apartments in Tacoma, Tacoma",
  "property_seo_description_faqs": "Uncover answers about The Lex in Tacoma! From studio to two-bedroom floor plans and amenities like the sky lounge, we’ve got you covered. Visit FAQs now!",
  "property_seo_title_reviews": "Resident Reviews | Apartments For Rent With Fitness Center",
  "property_seo_description_reviews": "Explore the glowing reviews left by residents at The Lex to learn more about our apartment community in Tacoma, WA.",
  "property_seo_title_applynow": "Apply Now | Apartments Near University of Washington Tacoma",
  "property_seo_description_applynow": "Ready to make The Lex your new home? Apply online for our spacious apts in WA in Downtown Tacoma and start your journey today!",
  "property_seo_title_residentaccess": "Resident Access | Downtown Tacoma Two Bedroom Apts",
  "property_seo_description_residentaccess": "At The Lex, our resident portal offers seamless 24/7 access, simplifying maintenance requests and rent payments for your convenience.",
  "property_seo_title_referafriend": "Refer A Friend | The Lex",
  "property_seo_description_referafriend": "Refer a friend to The Lex in Tacoma and build a community where great friends become great neighbors. Share the joy of apartment living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Luxury Apts With a Rooftop Deck",
  "property_seo_description_scheduletour": "Excited to explore The Lex in person? Arrange a tour to discover our amenities and open-concept apartment designs in Tacoma, WA!",
  "property_seo_title_privacy": "Privacy Policy | Spacious Studio Apts in Tacoma, WA",
  "property_seo_description_privacy": "Discover how we protect your privacy on our website. Read our privacy policy for more details and learn about our apartments for rent in Tacoma, WA!",
  "property_seo_title_accessibility": "Accessibility | One Bedroom Apts For Rent in Tacoma, WA",
  "property_seo_description_accessibility": "Explore our accessibility page and find out how we made our Tacoma, WA apartment website user-friendly for everyone.",
  "property_seo_title_sitemap": "Sitemap | The Lex in Downtown Tacoma",
  "property_seo_description_sitemap": "Navigate our website with ease. Check out our sitemap to find all the information you need and your new apartment in Tacoma, WA.",
  "property_seo_title_thankyou": "Thank You | Lease The Lex Apts in Downtown Tacoma, WA",
  "property_seo_description_thankyou": "Thank you for your interest in The Lex. We will process your request and get back to you shortly!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tacoma, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293567619",
  "amenities": [
    {
      "id": "ec_4a650b623a229a4a8c686dec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303615",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_972843e96c76bbfed0ccc6d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303614",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2856cdec969c9de4f9ab526a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303608",
      "title": "Rooftop Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57258500f953c270f72049ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303565",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b3f1921c6fc3d86f7dd5ea09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303567",
      "title": "Bike Storage and Maintenance Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc62a541fd72ba2a8944436a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303616",
      "title": "Sky Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7235a254800fd884586f7e77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "121922789",
      "title": "Furnished",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5094279abf7249107dea4dcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303631",
      "title": "Full-Size Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff09233eef5198e89b56ffc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303627",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce60f763671e5705b49a3e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95303626",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecc96bef6812a665bd894fa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95390905",
      "title": "Walk-In Closets*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_039a9981df798e0c1f3180c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95390863",
      "title": "Quartz Counters",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e03cfa917da2f0c11309540",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "yardi",
      "external_id": "95745358",
      "title": "Soft Close Cabinets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_2ea0d7dccba6ec09252f1783",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "title": "Community",
      "description": "A scenic aerial view of contemporary apartment buildings situated along the waterfront, offering a glimpse of the stunning natural landscape.",
      "link": "false",
      "alt_text": "Modern apartment buildings with a view of the water and mountains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/3b.jpg"
    },
    {
      "id": "ec_e4a221f082afcc53b15a071c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-29df-702c-b55a-2b36874770fe.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with a stylish island and comfortable seating.",
        "public_id": "019d0813-29df-702c-b55a-2b36874770fe",
        "storage_key": "property/6767906449164272/019d0813-29df-702c-b55a-2b36874770fe.webp",
        "width": 2600,
        "height": 1563
      },
      "title": "Apartment",
      "description": "Experience the spacious and modern design of our apartments, featuring a fully equipped kitchen and an inviting living area perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with a stylish island and comfortable seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/30B(1).jpg"
    },
    {
      "id": "ec_c3ccd4b9be824c11745afb95",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-367d-756d-b311-c858ee735805.webp",
      "image_media": {
        "alt_text": "Woman relaxing on a lounge chair on a balcony overlooking a cityscape and mountains.",
        "public_id": "019d0813-367d-756d-b311-c858ee735805",
        "storage_key": "property/6767906449164272/019d0813-367d-756d-b311-c858ee735805.webp",
        "width": 2600,
        "height": 1718
      },
      "title": "Lifestyle",
      "description": "Enjoy breathtaking views and relaxation on our rooftop terrace. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Woman relaxing on a lounge chair on a balcony overlooking a cityscape and mountains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Rooftop Deck (2).jpg"
    },
    {
      "id": "ec_5b0d71813cabfa430fbab7cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-30d6-7393-b94c-24e618654ddd.webp",
      "image_media": {
        "alt_text": "Billiard table and outdoor seating area with grills and a scenic water view.",
        "public_id": "019d0813-30d6-7393-b94c-24e618654ddd",
        "storage_key": "property/6767906449164272/019d0813-30d6-7393-b94c-24e618654ddd.webp",
        "width": 2800,
        "height": 1622
      },
      "title": "Community",
      "description": "Enjoy recreation and relaxation in our community lounge, featuring a billiard table and an expansive outdoor patio with grills and stunning water views.",
      "link": "false",
      "alt_text": "Billiard table and outdoor seating area with grills and a scenic water view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/15.jpg"
    },
    {
      "id": "ec_94b902c9850a28ff54223c29",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-3e87-74c8-a6f6-e6c2910455a2.webp",
      "image_media": {
        "alt_text": "Bedroom with yellow bedding, grey throw blanket, and modern art.",
        "public_id": "019d0813-3e87-74c8-a6f6-e6c2910455a2",
        "storage_key": "property/6767906449164272/019d0813-3e87-74c8-a6f6-e6c2910455a2.webp",
        "width": 2600,
        "height": 1682
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a queen-size bed with vibrant yellow linens, a cozy grey knit blanket, and striking modern artwork above the headboard. Includes a spacious closet and an ensuite bathroom entrance.",
      "link": "false",
      "alt_text": "Bedroom with yellow bedding, grey throw blanket, and modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/22B.jpg"
    },
    {
      "id": "ec_8f1c8e4c3cef5cf89085c56a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-4a01-7552-8ec6-580ca55d6b6a.webp",
      "image_media": {
        "alt_text": "Modern living room with a large TV, leather couch, and coffee table.",
        "public_id": "019d0813-4a01-7552-8ec6-580ca55d6b6a",
        "storage_key": "property/6767906449164272/019d0813-4a01-7552-8ec6-580ca55d6b6a.webp",
        "width": 2800,
        "height": 1503
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a large flat-screen TV, comfortable leather sectional, and a rustic wooden coffee table, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Modern living room with a large TV, leather couch, and coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/20.jpg"
    },
    {
      "id": "ec_a8f4b76c486d3227cbf229c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-52bc-7652-960b-885131ec8a0f.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with brick and white facade, overlooking a snow-capped mountain.",
        "public_id": "019d0813-52bc-7652-960b-885131ec8a0f",
        "storage_key": "property/6767906449164272/019d0813-52bc-7652-960b-885131ec8a0f.webp",
        "width": 2215,
        "height": 3072
      },
      "title": "Community",
      "description": "Experience modern living in this stunning apartment building, featuring a sleek exterior design with striking brick accents. Enjoy breathtaking views of the majestic snow-capped mountain from this prime location.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with brick and white facade, overlooking a snow-capped mountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/45.jpg"
    },
    {
      "id": "ec_1b4a038ed03e3645297231c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-4f7a-74da-9efb-1e697ccb7144.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with cardio machines, weight racks, and free weights.",
        "public_id": "019d0813-4f7a-74da-9efb-1e697ccb7144",
        "storage_key": "property/6767906449164272/019d0813-4f7a-74da-9efb-1e697ccb7144.webp",
        "width": 3072,
        "height": 1826
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights for a complete workout.",
      "link": "false",
      "alt_text": "Modern apartment gym with cardio machines, weight racks, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Fitness Center(1).jpg"
    },
    {
      "id": "ec_9de7b27c5815cc5383826e9f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-5b7d-70a9-89d0-fadc3d19587b.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with seating, fire pit, and outdoor kitchen.",
        "public_id": "019d0813-5b7d-70a9-89d0-fadc3d19587b",
        "storage_key": "property/6767906449164272/019d0813-5b7d-70a9-89d0-fadc3d19587b.webp",
        "width": 2560,
        "height": 1596
      },
      "title": "Community",
      "description": "Enjoy the rooftop lounge with comfortable seating, a fire pit, and an outdoor kitchen, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Rooftop lounge area with seating, fire pit, and outdoor kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/10(1).jpg"
    },
    {
      "id": "ec_c1b69e5d9e3e1729813c7e46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-66bc-737c-a988-b0e88e60e4ec.webp",
      "image_media": {
        "alt_text": "Stylish home office with a rustic wooden desk and black leather chair next to a living area.",
        "public_id": "019d0813-66bc-737c-a988-b0e88e60e4ec",
        "storage_key": "property/6767906449164272/019d0813-66bc-737c-a988-b0e88e60e4ec.webp",
        "width": 2800,
        "height": 1561
      },
      "title": "Apartment",
      "description": "Discover a comfortable and chic home office space, perfect for work or study, integrated with the modern living area of your apartment.",
      "link": "false",
      "alt_text": "Stylish home office with a rustic wooden desk and black leather chair next to a living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/25.jpg"
    },
    {
      "id": "ec_3d5abcd84e23ae0a3514bf13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-61e7-7567-b262-79d80003fea7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a sink, vanity, stacked washer and dryer, and a fluffy white robe hanging.",
        "public_id": "019d0813-61e7-7567-b262-79d80003fea7",
        "storage_key": "property/6767906449164272/019d0813-61e7-7567-b262-79d80003fea7.webp",
        "width": 2600,
        "height": 1675
      },
      "title": "Apartment",
      "description": "Experience ultimate convenience with an in-unit washer and dryer in your spacious bathroom. This apartment offers modern amenities for comfortable living.",
      "link": "false",
      "alt_text": "Modern bathroom with a sink, vanity, stacked washer and dryer, and a fluffy white robe hanging.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/19B.jpg"
    },
    {
      "id": "ec_dc9882f482a46889be114d7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-6dae-777a-a992-78da70301333.webp",
      "image_media": {
        "alt_text": "Modern bathroom with stacked washer and dryer, vanity, and tub/shower combo.",
        "public_id": "019d0813-6dae-777a-a992-78da70301333",
        "storage_key": "property/6767906449164272/019d0813-6dae-777a-a992-78da70301333.webp",
        "width": 2800,
        "height": 1733
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a stacked washer and dryer, elegant vanity with a modern faucet, and a clean tub/shower combination. Perfect for convenience and style.",
      "link": "false",
      "alt_text": "Modern bathroom with stacked washer and dryer, vanity, and tub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/29.jpg"
    },
    {
      "id": "ec_880d797a782899e6ffe89a9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-7f15-7201-aedc-8600ab5a28be.webp",
      "image_media": {
        "alt_text": "Modern home office with a wooden desk, black office chair, and Banksy-inspired art.",
        "public_id": "019d0813-7f15-7201-aedc-8600ab5a28be",
        "storage_key": "property/6767906449164272/019d0813-7f15-7201-aedc-8600ab5a28be.webp",
        "width": 2800,
        "height": 1806
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this stylish apartment, featuring a modern desk setup and unique wall art.",
      "link": "false",
      "alt_text": "Modern home office with a wooden desk, black office chair, and Banksy-inspired art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/26(1).jpg"
    },
    {
      "id": "ec_7db9a23763247ccd8c2275b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-7d87-74c9-927a-bd90e0965e2c.webp",
      "image_media": {
        "alt_text": "Exterior view of The Lex 415 apartment buildings",
        "public_id": "019d0813-7d87-74c9-927a-bd90e0965e2c",
        "storage_key": "property/6767906449164272/019d0813-7d87-74c9-927a-bd90e0965e2c.webp",
        "width": 1866,
        "height": 1900
      },
      "title": "Community",
      "description": "Modern apartment buildings with diverse facade designs, including brick and dark siding with wood accents. Features include balconies, large windows, and street-level retail spaces.",
      "link": "false",
      "alt_text": "Exterior view of The Lex 415 apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/15b.jpg"
    },
    {
      "id": "ec_9242ba11a1343dd9d6cc3b6b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-7e2d-7674-ab1c-c9f5edd7f958.webp",
      "image_media": {
        "alt_text": "Mailroom with blue and black mailboxes and a large mural on the wall.",
        "public_id": "019d0813-7e2d-7674-ab1c-c9f5edd7f958",
        "storage_key": "property/6767906449164272/019d0813-7e2d-7674-ab1c-c9f5edd7f958.webp",
        "width": 3072,
        "height": 2100
      },
      "title": "Community",
      "description": "Bright and modern mailroom featuring vibrant blue mailboxes and a striking industrial-themed mural, offering residents a convenient and stylish space for their mail.",
      "link": "false",
      "alt_text": "Mailroom with blue and black mailboxes and a large mural on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/10(2).jpg"
    },
    {
      "id": "ec_5c3b0138f792fdf410f61d79",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-874a-737b-916a-eac86fc62594.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, yellow comforter, and artwork of monkeys.",
        "public_id": "019d0813-874a-737b-916a-eac86fc62594",
        "storage_key": "property/6767906449164272/019d0813-874a-737b-916a-eac86fc62594.webp",
        "width": 2600,
        "height": 1731
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a king-size bed with a yellow comforter and decorative pillows, accented by unique wall art and a sliding door with frosted glass.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, yellow comforter, and artwork of monkeys.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/23B.jpg"
    },
    {
      "id": "ec_0b3cd36e9943d5c075e211ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-9a8e-762f-802d-bd0756c02465.webp",
      "image_media": {
        "alt_text": "Bedroom with a large teal bed, decorative pillows, and Banksy-style artwork on the wall.",
        "public_id": "019d0813-9a8e-762f-802d-bd0756c02465",
        "storage_key": "property/6767906449164272/019d0813-9a8e-762f-802d-bd0756c02465.webp",
        "width": 2800,
        "height": 1512
      },
      "title": "Apartment",
      "description": "Relax in this stylish bedroom featuring a comfortable bed adorned with decorative pillows and a captivating piece of modern art.",
      "link": "false",
      "alt_text": "Bedroom with a large teal bed, decorative pillows, and Banksy-style artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/28(1).jpg"
    },
    {
      "id": "ec_f83d5a315ff2c35264a20f33",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-a2d6-7048-a5c6-beaa36afba01.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, ellipticals, free weights, and a water fountain.",
        "public_id": "019d0813-a2d6-7048-a5c6-beaa36afba01",
        "storage_key": "property/6767906449164272/019d0813-a2d6-7048-a5c6-beaa36afba01.webp",
        "width": 3072,
        "height": 1679
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, free weights, and a refreshing water fountain for your convenience.",
      "link": "false",
      "alt_text": "Modern fitness center with treadmills, ellipticals, free weights, and a water fountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Fitness Center (5).jpg"
    },
    {
      "id": "ec_c8d2bca844f2b865d956537b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-94bd-72c9-9153-ef3b7f6e9520.webp",
      "image_media": {
        "alt_text": "Modern living room with leather sofa, metallic coffee table, and artwork.",
        "public_id": "019d0813-94bd-72c9-9153-ef3b7f6e9520",
        "storage_key": "property/6767906449164272/019d0813-94bd-72c9-9153-ef3b7f6e9520.webp",
        "width": 2600,
        "height": 1597
      },
      "title": "Apartment",
      "description": "Stylish living area featuring a comfortable leather sofa, a unique metallic coffee table, and contemporary wall art, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Modern living room with leather sofa, metallic coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/29B.jpg"
    },
    {
      "id": "ec_cf49dd62a56796a1bd37693c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-9e83-7034-883a-2d3e359b25d9.webp",
      "image_media": {
        "alt_text": "Door to pup spa with a painting of a white dog above the sign.",
        "public_id": "019d0813-9e83-7034-883a-2d3e359b25d9",
        "storage_key": "property/6767906449164272/019d0813-9e83-7034-883a-2d3e359b25d9.webp",
        "width": 3072,
        "height": 2820
      },
      "title": "Community",
      "description": "Entrance to the pup spa, complete with a playful painting of a white dog.",
      "link": "false",
      "alt_text": "Door to pup spa with a painting of a white dog above the sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Paw Spa (2).jpg"
    },
    {
      "id": "ec_a22796186636603597eaaa09",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-bf8b-713b-a751-c30271723acc.webp",
      "image_media": {
        "alt_text": "The Lex apartment building exterior with signage and building number 415.",
        "public_id": "019d0813-bf8b-713b-a751-c30271723acc",
        "storage_key": "property/6767906449164272/019d0813-bf8b-713b-a751-c30271723acc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior with prominent \"The Lex\" signage and building number 415. Offers a glimpse of the property's architecture and entryway.",
      "link": "false",
      "alt_text": "The Lex apartment building exterior with signage and building number 415.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/43.jpg"
    },
    {
      "id": "ec_f424f5a809200a6d82b83908",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-b5f2-74d7-9a46-710a03bda622.webp",
      "image_media": {
        "alt_text": "Rooftop deck with lounge chairs and a view of the water and distant hills.",
        "public_id": "019d0813-b5f2-74d7-9a46-710a03bda622",
        "storage_key": "property/6767906449164272/019d0813-b5f2-74d7-9a46-710a03bda622.webp",
        "width": 2600,
        "height": 1580
      },
      "title": "Community",
      "description": "Enjoy the stunning waterfront views from your private rooftop deck, complete with comfortable lounge seating for ultimate relaxation.",
      "link": "false",
      "alt_text": "Rooftop deck with lounge chairs and a view of the water and distant hills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Rooftop Deck.jpg"
    },
    {
      "id": "ec_8c345f22ee3fbaed059e56c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-b94d-74c9-9e53-86a7b77bdc90.webp",
      "image_media": {
        "alt_text": "Exterior of modern apartment building with dark facade and wood accents.",
        "public_id": "019d0813-b94d-74c9-9e53-86a7b77bdc90",
        "storage_key": "property/6767906449164272/019d0813-b94d-74c9-9e53-86a7b77bdc90.webp",
        "width": 2336,
        "height": 1900
      },
      "title": "Community",
      "description": "Modern apartment building exterior with striking dark facade and warm wood accents. Showcases contemporary architecture and design.",
      "link": "false",
      "alt_text": "Exterior of modern apartment building with dark facade and wood accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/14(1).jpg"
    },
    {
      "id": "ec_6d4c4284e7e24f70d5e23cf7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-c4cd-753b-a6fe-0f07aa87be6f.webp",
      "image_media": {
        "alt_text": "Weight rack with weights and a bench in a fitness center.",
        "public_id": "019d0813-c4cd-753b-a6fe-0f07aa87be6f",
        "storage_key": "property/6767906449164272/019d0813-c4cd-753b-a6fe-0f07aa87be6f.webp",
        "width": 3072,
        "height": 1900
      },
      "title": "Community",
      "description": "Fully equipped fitness center with cardio machines, weight racks, and free weights for residents to use.",
      "link": "false",
      "alt_text": "Weight rack with weights and a bench in a fitness center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Fitness Center (2).jpg"
    },
    {
      "id": "ec_1c40e2e7ca60c8aedc138ade",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-d388-75fd-ba21-b8c65f16a57a.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with large windows and island.",
        "public_id": "019d0813-d388-75fd-ba21-b8c65f16a57a",
        "storage_key": "property/6767906449164272/019d0813-d388-75fd-ba21-b8c65f16a57a.webp",
        "width": 2600,
        "height": 1699
      },
      "title": "Apartment",
      "description": "Spacious studio apartment featuring a combined living and kitchen area, perfect for modern living. Enjoy ample natural light and a stylish, functional design.",
      "link": "false",
      "alt_text": "Modern living room and kitchen with large windows and island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/27B.jpg"
    },
    {
      "id": "ec_9632d9ef3fb96c52ce66c3a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-d694-7754-87ad-116b2c73b8b3.webp",
      "image_media": {
        "alt_text": "View of a city skyline with a large mountain in the background.",
        "public_id": "019d0813-d694-7754-87ad-116b2c73b8b3",
        "storage_key": "property/6767906449164272/019d0813-d694-7754-87ad-116b2c73b8b3.webp",
        "width": 2600,
        "height": 1734
      },
      "title": "Community",
      "description": "Panoramic view of the city with a majestic mountain in the distance, showcasing the vibrant urban landscape and natural beauty.",
      "link": "false",
      "alt_text": "View of a city skyline with a large mountain in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/changed river color.jpg"
    },
    {
      "id": "ec_b4d13a91412f4bd8cdade03e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-52bc-7652-960b-885131ec8a0f.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with brick and white facade, overlooking a snow-capped mountain.",
        "public_id": "019d0813-52bc-7652-960b-885131ec8a0f",
        "storage_key": "property/6767906449164272/019d0813-52bc-7652-960b-885131ec8a0f.webp",
        "width": 2215,
        "height": 3072
      },
      "title": "Community",
      "description": "Experience modern living in this stunning apartment building, featuring a sleek exterior design with striking brick accents. Enjoy breathtaking views of the majestic snow-capped mountain from this prime location.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with brick and white facade, overlooking a snow-capped mountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/45(1).jpg"
    },
    {
      "id": "ec_3690252d5355da3244d995c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-e67b-7139-8b71-fb1350a835c8.webp",
      "image_media": {
        "alt_text": "Modern communal lounge with blue couches, armchairs, and rustic coffee tables.",
        "public_id": "019d0813-e67b-7139-8b71-fb1350a835c8",
        "storage_key": "property/6767906449164272/019d0813-e67b-7139-8b71-fb1350a835c8.webp",
        "width": 2800,
        "height": 1687
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal lounge, featuring comfortable seating and a contemporary design.",
      "link": "false",
      "alt_text": "Modern communal lounge with blue couches, armchairs, and rustic coffee tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/13.jpg"
    },
    {
      "id": "ec_d2c558e25b45a11153c43f4f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-f0e2-735b-841c-108489bdae60.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, green bedding, and modern art on the wall.",
        "public_id": "019d0813-f0e2-735b-841c-108489bdae60",
        "storage_key": "property/6767906449164272/019d0813-f0e2-735b-841c-108489bdae60.webp",
        "width": 2800,
        "height": 1825
      },
      "title": "Apartment",
      "description": "Relax in this stylish bedroom featuring a comfortable queen-sized bed, plush bedding, and unique wall art. A perfect retreat after a long day.",
      "link": "false",
      "alt_text": "Bedroom with a queen bed, green bedding, and modern art on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/27.jpg"
    },
    {
      "id": "ec_d0febcb0d87cab9791a6cf8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-f45f-75ac-86b8-4f3170f27ae3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island bar seating, stainless steel appliances, and ample cabinet space.",
        "public_id": "019d0813-f45f-75ac-86b8-4f3170f27ae3",
        "storage_key": "property/6767906449164272/019d0813-f45f-75ac-86b8-4f3170f27ae3.webp",
        "width": 2800,
        "height": 1951
      },
      "title": "Apartment",
      "description": "Chic kitchen featuring a spacious island with bar stools, perfect for casual dining and entertaining. Modern finishes and stainless steel appliances complete this stylish space.",
      "link": "false",
      "alt_text": "Modern kitchen with island bar seating, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/24.jpg"
    },
    {
      "id": "ec_46625d0504e0853cec041000",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-0077-7030-b795-eb1a4a6757eb.webp",
      "image_media": {
        "alt_text": "Interior common area with a large mural and seating areas.",
        "public_id": "019d0814-0077-7030-b795-eb1a4a6757eb",
        "storage_key": "property/6767906449164272/019d0814-0077-7030-b795-eb1a4a6757eb.webp",
        "width": 2800,
        "height": 1620
      },
      "title": "Community",
      "description": "This image shows a stylish and modern common area within a multifamily property, featuring a vibrant mural and comfortable seating options.",
      "link": "false",
      "alt_text": "Interior common area with a large mural and seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/11.jpg"
    },
    {
      "id": "ec_c82b84c3f4551c1a00018acf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-06e6-7138-b6c4-56f7c126b18f.webp",
      "image_media": {
        "alt_text": "Modern lounge area with fireplace and large windows overlooking the city.",
        "public_id": "019d0814-06e6-7138-b6c4-56f7c126b18f",
        "storage_key": "property/6767906449164272/019d0814-06e6-7138-b6c4-56f7c126b18f.webp",
        "width": 2800,
        "height": 1737
      },
      "title": "Community",
      "description": "Relax in style in our modern lounge, featuring a cozy fireplace, comfortable seating, and stunning city views. Perfect for socializing or unwinding.",
      "link": "false",
      "alt_text": "Modern lounge area with fireplace and large windows overlooking the city.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/1.jpg"
    },
    {
      "id": "ec_bd5997d0893d701ed14bbab9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-0f75-7149-a5a0-14c694bf2d30.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with comfortable seating, bar stools, and a large black and white photo on the wall.",
        "public_id": "019d0814-0f75-7149-a5a0-14c694bf2d30",
        "storage_key": "property/6767906449164272/019d0814-0f75-7149-a5a0-14c694bf2d30.webp",
        "width": 2800,
        "height": 1711
      },
      "title": "Community",
      "description": "Relax and socialize in our modern lounge area, featuring plush seating, a bar, and a striking art piece, perfect for unwinding or catching up with neighbors.",
      "link": "false",
      "alt_text": "Stylish lounge area with comfortable seating, bar stools, and a large black and white photo on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/7.jpg"
    },
    {
      "id": "ec_6151ef7283b3bdc0b26d7e95",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-1601-7329-b87f-05e8c5a119ce.webp",
      "image_media": {
        "alt_text": "Communal kitchen and dining area with modern seating and a scenic view.",
        "public_id": "019d0814-1601-7329-b87f-05e8c5a119ce",
        "storage_key": "property/6767906449164272/019d0814-1601-7329-b87f-05e8c5a119ce.webp",
        "width": 2800,
        "height": 1724
      },
      "title": "Community",
      "description": "Enjoy our stylish communal kitchen and dining area, perfect for entertaining or casual gatherings. Features modern appliances, ample seating, and stunning city views.",
      "link": "false",
      "alt_text": "Communal kitchen and dining area with modern seating and a scenic view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/17(2).jpg"
    },
    {
      "id": "ec_d11143b01c3c0565ec0ae30e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-2169-745c-ac5a-0f1ad60cfb99.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with large windows, seating, and tables, leading to an outdoor patio with a view.",
        "public_id": "019d0814-2169-745c-ac5a-0f1ad60cfb99",
        "storage_key": "property/6767906449164272/019d0814-2169-745c-ac5a-0f1ad60cfb99.webp",
        "width": 2800,
        "height": 1833
      },
      "title": "Community",
      "description": "Enjoy our stylish communal lounge, featuring ample seating, dining areas, and a connection to an outdoor patio with scenic views, perfect for socializing or relaxing.",
      "link": "false",
      "alt_text": "Modern communal lounge area with large windows, seating, and tables, leading to an outdoor patio with a view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/14(2).jpg"
    },
    {
      "id": "ec_75002a2a4c2682c7193c21bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-24cb-7659-8535-65342c435e11.webp",
      "image_media": {
        "alt_text": "Modern living room with comfortable seating, coffee table, and large window.",
        "public_id": "019d0814-24cb-7659-8535-65342c435e11",
        "storage_key": "property/6767906449164272/019d0814-24cb-7659-8535-65342c435e11.webp",
        "width": 2800,
        "height": 1807
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, perfect for entertaining or quiet evenings.",
      "link": "false",
      "alt_text": "Modern living room with comfortable seating, coffee table, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/21.jpg"
    },
    {
      "id": "ec_7ebc45b927a604dacaade4e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-3280-71a6-be19-4fb754323adb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a breakfast bar and stools, stainless steel appliances, and ample cabinet space.",
        "public_id": "019d0814-3280-71a6-be19-4fb754323adb",
        "storage_key": "property/6767906449164272/019d0814-3280-71a6-be19-4fb754323adb.webp",
        "width": 2800,
        "height": 1721
      },
      "title": "Apartment",
      "description": "This stylish apartment kitchen features a sleek breakfast bar with comfortable stools, perfect for casual dining or entertaining. Enjoy modern stainless steel appliances and plenty of storage.",
      "link": "false",
      "alt_text": "Modern kitchen with a breakfast bar and stools, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/22.jpg"
    },
    {
      "id": "ec_4c3d3cc0ad37dea6714e66c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-2d8f-741e-a133-a698b6fe94ef.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019d0814-2d8f-741e-a133-a698b6fe94ef",
        "storage_key": "property/6767906449164272/019d0814-2d8f-741e-a133-a698b6fe94ef.webp",
        "width": 2600,
        "height": 1664
      },
      "title": "Apartment",
      "description": "Step into this chic bathroom, featuring a sleek vanity, a modern toilet, and a bathtub with a stylish shower curtain. The perfect blend of form and function.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/16C.jpg"
    },
    {
      "id": "ec_44d4f16378466a5e7a90f4c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-53a3-757a-99f2-fe9752653164.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with island and stainless steel appliances, overlooking water view.",
        "public_id": "019d0814-53a3-757a-99f2-fe9752653164",
        "storage_key": "property/6767906449164272/019d0814-53a3-757a-99f2-fe9752653164.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen featuring a large island with sink and dishwasher, modern cabinetry, and stunning water views from the adjacent living area.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with island and stainless steel appliances, overlooking water view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Lex-Unit 601-POI-012.jpg"
    },
    {
      "id": "ec_ce2d7df8e9d3dd46ce64caed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-4e80-71bd-99c3-9eff96931b9e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island, and gray cabinetry.",
        "public_id": "019d0814-4e80-71bd-99c3-9eff96931b9e",
        "storage_key": "property/6767906449164272/019d0814-4e80-71bd-99c3-9eff96931b9e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, a central island, and sleek countertops.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, island, and gray cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/The Lex-Unit 111-POI-004.jpg"
    },
    {
      "id": "ec_9dda7e1b8fb580c32862e26d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-52f0-7732-bf80-6ce973de9072.webp",
      "image_media": {
        "alt_text": "Modern hallway with blue chairs and abstract carpet",
        "public_id": "019d0814-52f0-7732-bf80-6ce973de9072",
        "storage_key": "property/6767906449164272/019d0814-52f0-7732-bf80-6ce973de9072.webp",
        "width": 2800,
        "height": 1909
      },
      "title": "Community",
      "description": "A stylishly designed hallway featuring comfortable blue seating, modern pendant lights, and eye-catching abstract carpeting, creating a welcoming ambiance.",
      "link": "false",
      "alt_text": "Modern hallway with blue chairs and abstract carpet",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/32(1).jpg"
    },
    {
      "id": "ec_8f6226035eca1128c258f7e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-4833-735e-9299-a5cc7602f4ba.webp",
      "image_media": {
        "alt_text": "Parking garage entrance with the word PARKING above two large doors.",
        "public_id": "019d0814-4833-735e-9299-a5cc7602f4ba",
        "storage_key": "property/6767906449164272/019d0814-4833-735e-9299-a5cc7602f4ba.webp",
        "width": 2560,
        "height": 1139
      },
      "title": "Community",
      "description": "Secure parking garage entrance. Offers convenient and safe parking for residents and guests.",
      "link": "false",
      "alt_text": "Parking garage entrance with the word PARKING above two large doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/17(1).jpg"
    },
    {
      "id": "ec_1e4d9aa9dee3092b1f5408df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-6bc1-707a-b9c3-93aeee1b2d72.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, coffee table, and large window with city view.",
        "public_id": "019d0814-6bc1-707a-b9c3-93aeee1b2d72",
        "storage_key": "property/6767906449164272/019d0814-6bc1-707a-b9c3-93aeee1b2d72.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Enjoy stunning city and water views from the comfort of your stylish living room, featuring comfortable seating and modern decor.",
      "link": "false",
      "alt_text": "Modern living room with sofa, coffee table, and large window with city view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/509_The Lex_MU A1_D6_Cam5.jpg"
    },
    {
      "id": "ec_f0b77a73d953d170c28b18af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-6d03-728a-8b54-8d3eca219094.webp",
      "image_media": {
        "alt_text": "A beautifully staged bedroom with a queen-sized bed, modern decor, and a large closet.",
        "public_id": "019d0814-6d03-728a-8b54-8d3eca219094",
        "storage_key": "property/6767906449164272/019d0814-6d03-728a-8b54-8d3eca219094.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this well-appointed bedroom, featuring a plush queen bed, ample closet space, and a contemporary aesthetic.",
      "link": "false",
      "alt_text": "A beautifully staged bedroom with a queen-sized bed, modern decor, and a large closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/509_The Lex_MU A1_D6_Cam4 .jpg"
    },
    {
      "id": "ec_f792e81176c39f20d8131981",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-8229-7102-b46b-d1be61e87f97.webp",
      "image_media": {
        "alt_text": "City skyline with bridge and water in the background.",
        "public_id": "019d0814-8229-7102-b46b-d1be61e87f97",
        "storage_key": "property/6767906449164272/019d0814-8229-7102-b46b-d1be61e87f97.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Panoramic view of a vibrant city skyline featuring modern architecture, a distinctive bridge, and a body of water.",
      "link": "false",
      "alt_text": "City skyline with bridge and water in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Tacoma Skyline 1.jpg"
    },
    {
      "id": "ec_dc0a01d00f79aaf1c74a5d8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-6caf-767e-94a6-8b5818938914.webp",
      "image_media": {
        "alt_text": "Stadium Historic District street lamp with banner",
        "public_id": "019d0814-6caf-767e-94a6-8b5818938914",
        "storage_key": "property/6767906449164272/019d0814-6caf-767e-94a6-8b5818938914.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Street lamp with a banner advertising the Stadium Historic District, featuring a historic building.",
      "link": "false",
      "alt_text": "Stadium Historic District street lamp with banner",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Stadium Historic Dist sign.jpg"
    },
    {
      "id": "ec_5dfc4628dd3c91ee3bb62fb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0ec6-941f-70e7-82bf-1d12a0f3d78e.webp",
      "image_media": {
        "alt_text": "Panoramic view of a waterfront city with historic buildings and a clock tower.",
        "public_id": "019d0ec6-941f-70e7-82bf-1d12a0f3d78e",
        "storage_key": "property/6767906449164272/019d0ec6-941f-70e7-82bf-1d12a0f3d78e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience the vibrant cityscape from your doorstep, with stunning views of the waterfront, historic architecture, and convenient access to urban amenities.",
      "link": "false",
      "alt_text": "Panoramic view of a waterfront city with historic buildings and a clock tower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Commencement Bay 6.jpg"
    },
    {
      "id": "ec_832596569f1b352b1d781a4a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-9156-77cc-8240-bbcc979de0cc.webp",
      "image_media": {
        "alt_text": "Street view of a brick building facade with shops and parked cars along the sidewalk.",
        "public_id": "019d0814-9156-77cc-8240-bbcc979de0cc",
        "storage_key": "property/6767906449164272/019d0814-9156-77cc-8240-bbcc979de0cc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience the vibrant atmosphere of our neighborhood with charming brick buildings, local shops, and convenient street parking.",
      "link": "false",
      "alt_text": "Street view of a brick building facade with shops and parked cars along the sidewalk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Opera Alley 3.jpg"
    },
    {
      "id": "ec_60349b617628984c6decafba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-82fc-72ac-b879-6d8c77afe483.webp",
      "image_media": {
        "alt_text": "Chalkboard sign with 'Live Local, Shop Local, Eat Local' written in white chalk.",
        "public_id": "019d0814-82fc-72ac-b879-6d8c77afe483",
        "storage_key": "property/6767906449164272/019d0814-82fc-72ac-b879-6d8c77afe483.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "A rustic chalkboard sign with the message 'Live Local, Shop Local, Eat Local' displayed prominently.",
      "link": "false",
      "alt_text": "Chalkboard sign with 'Live Local, Shop Local, Eat Local' written in white chalk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Thriftway 3.jpg"
    },
    {
      "id": "ec_16ecf6287ca88a038f3d9b03",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0814-9ef2-7507-8a0c-114668d491e0.webp",
      "image_media": {
        "alt_text": "Wright Park established 1890 monument sign with park map and amenities list.",
        "public_id": "019d0814-9ef2-7507-8a0c-114668d491e0",
        "storage_key": "property/6767906449164272/019d0814-9ef2-7507-8a0c-114668d491e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Wright Park, established in 1890. This monument sign provides a map of the park and lists amenities such as the W.W. Seymour Botanical Conservatory, restrooms, picnic areas, and more.",
      "link": "false",
      "alt_text": "Wright Park established 1890 monument sign with park map and amenities list.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Wright Park 7.jpg"
    },
    {
      "id": "ec_b0b8557a099d612a927a52f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0ec6-b23e-70ef-9101-a56beeb78f95.webp",
      "image_media": {
        "alt_text": "Serene pond with two fountains and lush greenery.",
        "public_id": "019d0ec6-b23e-70ef-9101-a56beeb78f95",
        "storage_key": "property/6767906449164272/019d0ec6-b23e-70ef-9101-a56beeb78f95.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the tranquility of our community's beautiful pond, complete with refreshing fountains and vibrant natural surroundings.",
      "link": "false",
      "alt_text": "Serene pond with two fountains and lush greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Wright Park 8.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b2022f33-6828-4f31-b9c7-00dae2efdff9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "MultiCare Health System",
      "poi_type": "Health and Wellness",
      "poi_address": "820 A St, Tacoma, WA 98402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d6cdf-99d8-7797-aff0-02eab172f64a.webp",
      "poi_featured_image_media": {
        "alt_text": "Newborn baby wrapped in a blanket with bunnies, held by a person in surgical scrubs.",
        "public_id": "019d6cdf-99d8-7797-aff0-02eab172f64a",
        "storage_key": "property/6767906449164272/019d6cdf-99d8-7797-aff0-02eab172f64a.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "https://www.multicare.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2700924144086347343&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "multicare-health-system",
      "poi_latitude": "47.2558862",
      "poi_longitude": "-122.4380952",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-403-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwARMQZVkFQRT-6K7TKceyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a7bbd2a8-c822-48be-a746-e97856c674c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "McMenamins Pub at Elks Temple",
      "poi_type": "Restaurants",
      "poi_address": "565 Broadway, Tacoma, WA 98402, USA",
      "poi_short_description": "Elaborate eatery and hotel featuring a tiki bar, a speakeasy and live music.",
      "poi_long_description": "People say this pub offers delicious food, including burgers, pizza, and Cajun tots, and a wide selection of beers and cocktails. They highlight the unique and eclectic atmosphere, with multiple bars, a hidden speakeasy, and a tiki bar, as well as the beautiful decor, featuring murals, hand-carved wood pieces, and stained glass. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-aeea-72ff-8021-8dfc2f145b8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-aeea-72ff-8021-8dfc2f145b8f",
        "storage_key": "property/6767906449164272/019dcf9e-aeea-72ff-8021-8dfc2f145b8f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mcmenamins.com/elks-temple/mcmenamins-pub-at-elks-temple",
      "poi_directions_map_url": "https://maps.google.com/?cid=10184447355806378226&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcmenamins-pub-at-elks-temple",
      "poi_latitude": "47.2579654",
      "poi_longitude": "-122.4409506",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-300-8754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-d05f-7108-a23e-666faec4125c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcf9e-d05f-7108-a23e-666faec4125c",
        "storage_key": "property/6767906449164272/019dcf9e-d05f-7108-a23e-666faec4125c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG4_tEtNVkFQR8miBHOlsVo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_10c6925f-89ed-4ae1-ae12-e6b69ffdeff5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Doyle's Public House",
      "poi_type": "Restaurants",
      "poi_address": "208 St Helens Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Classic pub featuring imported beers, scotch & whiskey plus bar food & soccer on TV.",
      "poi_long_description": "People say this pub offers a wide selection of whiskeys, scotch eggs, and a \"Simple Sandwich,\" as well as a hearty breakfast menu with biscuits and gravy. They highlight the reasonable prices, generous portions, and fun, welcoming atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-ab61-73af-8ae1-4728decbf24d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-ab61-73af-8ae1-4728decbf24d",
        "storage_key": "property/6767906449164272/019dcf9e-ab61-73af-8ae1-4728decbf24d.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.doylespublichouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1669111222793949844&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "doyles-public-house",
      "poi_latitude": "47.2618263",
      "poi_longitude": "-122.4459575",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-272-7468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-d05f-7108-a23e-666faec4125c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcf9e-d05f-7108-a23e-666faec4125c",
        "storage_key": "property/6767906449164272/019dcf9e-d05f-7108-a23e-666faec4125c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBySWiKhVkFQRlFJAVdDfKRc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_acbe6b13-39fd-47cf-9746-3e7535a52ccc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Frisko Freeze",
      "poi_type": "Restaurants",
      "poi_address": "1201 Division Ave, Tacoma, WA 98403, USA",
      "poi_short_description": "Landmark quick-serve spot with retro style & a choice of drive-thru or walk-up ordering.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, fries, and shakes. They also highlight the affordable prices, retro vibes, and friendly staff.\n\nSome reviews mention there can be a long wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-adab-73bb-8a72-c3f869678d44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-adab-73bb-8a72-c3f869678d44",
        "storage_key": "property/6767906449164272/019dcf9e-adab-73bb-8a72-c3f869678d44.webp",
        "width": 1280,
        "height": 786
      },
      "poi_business_url": "http://friskofreeze.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11469024606919636434&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "frisko-freeze",
      "poi_latitude": "47.26006719999999",
      "poi_longitude": "-122.455623",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed91-763a-b320-7ff650fc8bc9",
        "storage_key": "property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl5hLaAZVkFQR0rWoTx0pKp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_b6ba2778-0174-4e8b-bfd6-1ecb28cdd7dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Hob Nob Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "716 6th Ave, Tacoma, WA 98405, USA",
      "poi_short_description": "Homestyle eats from breakfast to dinner in a no-frills diner with historic area photos on the walls.",
      "poi_long_description": "Diners like this diner's delicious and generously portioned breakfast and brunch items, especially the chicken fried steak, biscuits and gravy, and home fries. They also highlight the friendly and attentive staff, great atmosphere, and convenient location near a park.\n\nSome reviews mention there can be long wait times for service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b2c6-77e9-aa56-b392d5c917ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b2c6-77e9-aa56-b392d5c917ff",
        "storage_key": "property/6767906449164272/019dcf9e-b2c6-77e9-aa56-b392d5c917ff.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://hobnobtacoma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11316960198684308421&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hob-nob-restaurant",
      "poi_latitude": "47.2575027",
      "poi_longitude": "-122.4479285",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-272-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed91-763a-b320-7ff650fc8bc9",
        "storage_key": "property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe9yIywlVkFQRxfPPQ1frDZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_98b4f09c-d5d5-4ada-aab8-2ffdc74af29b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "MSM Deli",
      "poi_type": "Restaurants",
      "poi_address": "2220 6th Ave, Tacoma, WA 98403, USA",
      "poi_short_description": "Bustling sandwich shop featuring beer & large French bread creations, plus late-night weekend hours.",
      "poi_long_description": "People say this deli offers delicious sandwiches, including the popular Deli Club and Mike's Deluxe, with generous portions and fresh ingredients. They highlight the excellent bread, the perfect ratio of meat, cheese, and veggies, and the good value. They also like the friendly staff and the wide selection of drinks and chips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-ae1a-709b-9f45-8dbf0bbc2ed2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-ae1a-709b-9f45-8dbf0bbc2ed2",
        "storage_key": "property/6767906449164272/019dcf9e-ae1a-709b-9f45-8dbf0bbc2ed2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100064876984594&name=xhp_nt__fb__action__open_user",
      "poi_directions_map_url": "https://maps.google.com/?cid=471323420635214869&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "msm-deli",
      "poi_latitude": "47.2551618",
      "poi_longitude": "-122.4665727",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-272-4814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8c-72b5-b133-345c68f54996",
        "storage_key": "property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2zLuYhpVkFQRFbRIZSd6igY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_c6522a67-50e3-4728-a269-812126eec427",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Shake Shake Shake",
      "poi_type": "Restaurants",
      "poi_address": "124 N Tacoma Ave, Tacoma, WA 98403, USA",
      "poi_short_description": "Classic old-time American burgers, fries & shakes served in a charming, retro-inspired space.",
      "poi_long_description": "People say this hamburger restaurant serves delicious smash burgers, onion rings, and shakes. They also highlight the friendly staff, quick service, and retro diner vibe.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-ab36-75ab-a30b-9ea33cd6008b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-ab36-75ab-a30b-9ea33cd6008b",
        "storage_key": "property/6767906449164272/019dcf9e-ab36-75ab-a30b-9ea33cd6008b.webp",
        "width": 414,
        "height": 414
      },
      "poi_business_url": "https://shakeshakeshake.me/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=1747287544296859323&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "shake-shake-shake",
      "poi_latitude": "47.264788",
      "poi_longitude": "-122.44976",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-507-4060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed91-763a-b320-7ff650fc8bc9",
        "storage_key": "property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQfq7gqlVkFQRu2ZHlsOcPxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_307b5db5-ebfb-4a0b-873b-b556d3cbbe61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Farrelli's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "3518 6th Ave, Tacoma, WA 98406, USA",
      "poi_short_description": "Pizza hangout with create-your-own option, also serving other Italian fare & craft beers until late.",
      "poi_long_description": "Diners say this restaurant offers delicious pizza with fresh, plentiful toppings and great salad options, including dairy-free choices. They also highlight the friendly, attentive staff and the clean restrooms.\n\nSome reviews mention the prices can be expensive for the portion sizes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-ae87-72f9-9f37-a5ac30ee10f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-ae87-72f9-9f37-a5ac30ee10f4",
        "storage_key": "property/6767906449164272/019dcf9e-ae87-72f9-9f37-a5ac30ee10f4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://farrellispizza.com/locations/farrellis-tacoma-wa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10697747105685249611&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "farrellis-pizza",
      "poi_latitude": "47.2550649",
      "poi_longitude": "-122.4832796",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-759-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed91-763a-b320-7ff650fc8bc9",
        "storage_key": "property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5SjjiFVkFQRSx5VQ1AIdpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a1e0df9c-fa65-48ec-9f9e-ffd0e5d68b5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Corina Bakery",
      "poi_type": "Restaurants",
      "poi_address": "602 Fawcett Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Cozy bakery crafting sweet & savory treats (from cookies to quiche), espresso drinks & custom cakes.",
      "poi_long_description": "Bakery fans say this bakery offers a wide variety of delicious treats, including gluten-free and vegan options like croissants, cookies, muffins, scones, and birthday cakes, alongside excellent coffee and tea. They also highlight the cozy and inviting atmosphere, with many enjoying the local art displayed on the walls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-ab4a-725b-afd2-7bc17dcc7781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-ab4a-725b-afd2-7bc17dcc7781",
        "storage_key": "property/6767906449164272/019dcf9e-ab4a-725b-afd2-7bc17dcc7781.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://corinabakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3317501456121331291&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "corina-bakery",
      "poi_latitude": "47.2579639",
      "poi_longitude": "-122.444725",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-627-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed91-763a-b320-7ff650fc8bc9",
        "storage_key": "property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTVbKcadVkFQRW_7zWf8hCi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_6bdca767-97eb-4ee9-9b28-1a7c187fa7f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Zen Ramen & Sushi Burrito - Downtown Tacoma",
      "poi_type": "Restaurants",
      "poi_address": "322 Tacoma Ave S, Tacoma, WA 98402, USA",
      "poi_short_description": "Easygoing restaurant with a woodsy ambiance offering a creative twist on Japanese food.",
      "poi_long_description": "People say this Asian fusion restaurant serves delicious poke bowls, sushi burritos, and ramen. They highlight the fresh ingredients, generous portions, and affordable prices. They also like the fun, modern vibe and the friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b18e-735e-9584-475580c294c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b18e-735e-9584-475580c294c7",
        "storage_key": "property/6767906449164272/019dcf9e-b18e-735e-9584-475580c294c7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://zenramenbrothers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12088990257826073906&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "zen-ramen--sushi-burrito---downtown-tacoma",
      "poi_latitude": "47.2602066",
      "poi_longitude": "-122.4464438",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-302-3461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed91-763a-b320-7ff650fc8bc9",
        "storage_key": "property/6767906449164272/019d0815-ed91-763a-b320-7ff650fc8bc9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVIRm9lVkFQRMo3h2pa4xKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "custom_1e51ac67-4476-4540-8ade-bbfabf992d98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Stadium Thriftway",
      "poi_type": "Restaurants",
      "poi_address": "618 N 1st St, Tacoma, WA 98403, USA",
      "poi_short_description": "Grocery store for produce, wine, beer, hot and cold deli items, and coffee.",
      "poi_long_description": "People say this grocery store offers a wide selection of products, including run-of-the-mill items, vegan and vegetarian options, and bulk spices. They also highlight the friendly and helpful staff, and the delicious store-made food from the deli.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b22e-700a-8382-88c03057981b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b22e-700a-8382-88c03057981b",
        "storage_key": "property/6767906449164272/019dcf9e-b22e-700a-8382-88c03057981b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.stadiumthriftway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=905634084143585617&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stadium-thriftway",
      "poi_latitude": "47.263913",
      "poi_longitude": "-122.4487467",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-627-8275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8e-73f7-8e54-e823199cd190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8e-73f7-8e54-e823199cd190",
        "storage_key": "property/6767906449164272/019d0815-ed8e-73f7-8e54-e823199cd190.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWwRp6lVkFQRUVnduWZ1kQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_88c3d043-c521-438e-91cd-ff6c6096bdc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Mud Bay",
      "poi_type": "Restaurants",
      "poi_address": "635 Division Ave, Tacoma, WA 98403, USA",
      "poi_short_description": "Chain pet supply store in the Stadium District supplying healthy food and supplements for dogs and cats.",
      "poi_long_description": "People say this pet supply store offers a wide selection of pet goods, toys, and treats. They highlight the clean, organized, and expansive layout, and the friendly, attentive staff who offer treats to pets. They also like the helpful service, with staff offering to assist with carrying out large bags of pet food. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b955-742a-b7e8-4774f13e3632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b955-742a-b7e8-4774f13e3632",
        "storage_key": "property/6767906449164272/019dcf9e-b955-742a-b7e8-4774f13e3632.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mudbay.com/pet-store/STA-tacoma-WA?STA-tacoma-WA=",
      "poi_directions_map_url": "https://maps.google.com/?cid=1765918585790277299&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mud-bay",
      "poi_latitude": "47.2636846",
      "poi_longitude": "-122.4482177",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-448-8440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8c-72b5-b133-345c68f54996",
        "storage_key": "property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq8zCqalVkFQRsyZK-JjNgRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_0f613738-4f5e-4575-a6ef-5ac0907c24af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1965 S Union Ave, Tacoma, WA 98405, USA",
      "poi_short_description": "Department store chain stocking a variety of merchandise, including clothing, electronics, and furniture.",
      "poi_long_description": "Customers report that this superstore provides a wide variety of groceries, household items, and other products at great prices, and note that it is clean and well-stocked.\n\nOther reviews mention many items can be locked up, causing long waits for staff assistance, and service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b3dd-718d-9ca7-4166f672bbcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b3dd-718d-9ca7-4166f672bbcc",
        "storage_key": "property/6767906449164272/019dcf9e-b3dd-718d-9ca7-4166f672bbcc.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4137-tacoma-wa/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13951403034427529185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "47.2400228",
      "poi_longitude": "-122.4786318",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-414-9526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8c-72b5-b133-345c68f54996",
        "storage_key": "property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPWzJAThVkFQR4RdcYSRXncE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a7876680-24c5-435f-a638-29682a8234e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "2219 S 37th St, Tacoma, WA 98409, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide selection of items, including bulk goods, meat, and seasonal products. They highlight the great deals, low gas prices, and the food court's affordable hot dog and soda combo. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b51f-77aa-a210-c2cc106a4c8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b51f-77aa-a210-c2cc106a4c8b",
        "storage_key": "property/6767906449164272/019dcf9e-b51f-77aa-a210-c2cc106a4c8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/tacoma-WA-95.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=11551712085005299580&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "47.2253242",
      "poi_longitude": "-122.4681162",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-475-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8c-72b5-b133-345c68f54996",
        "storage_key": "property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE9es11VVkFQRfO9TDvDsT6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_b0ad49b8-a487-459c-8ec8-d014235bb14b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "King's Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "218 St Helens Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Quaint bookseller know for its deep inventory of new, used & out-of-print titles.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, including a discount section and a new book area, and has plenty of tables and chairs for reading or hanging out. They also highlight the friendly and helpful staff, and the two bookstore cats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b959-77a8-83de-fbd440da002c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b959-77a8-83de-fbd440da002c",
        "storage_key": "property/6767906449164272/019dcf9e-b959-77a8-83de-fbd440da002c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.kingsbookstore.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683060517723999587&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kings-books",
      "poi_latitude": "47.2617418",
      "poi_longitude": "-122.4456481",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-272-8801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8c-72b5-b133-345c68f54996",
        "storage_key": "property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJLTn6hqhVkFQRY41spp9uWxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_67cd2a8a-8aec-43c9-a99d-4ed451208c65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1112 S M St, Tacoma, WA 98405, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Some shoppers say this grocery store has friendly and helpful staff, and they appreciate the convenient parking and security.\n\nOther reviews mention prices can be high and the selection can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b762-710e-ae56-1c2759c9aab2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b762-710e-ae56-1c2759c9aab2",
        "storage_key": "property/6767906449164272/019dcf9e-b762-710e-ae56-1c2759c9aab2.webp",
        "width": 707,
        "height": 398
      },
      "poi_business_url": "https://local.safeway.com/safeway/wa/tacoma/1112-s-m-st.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11122882260832727201&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "47.2510858",
      "poi_longitude": "-122.4552776",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-627-8840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8e-73f7-8e54-e823199cd190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8e-73f7-8e54-e823199cd190",
        "storage_key": "property/6767906449164272/019d0815-ed8e-73f7-8e54-e823199cd190.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7x4_jA1VkFQRobBtE3xqXJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dac722ae-203b-4908-92eb-d68ad68e8bcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Metropolitan Market Tacoma",
      "poi_type": "Shopping & Retail",
      "poi_address": "2420 N Proctor St, Tacoma, WA 98406, USA",
      "poi_short_description": "Local chain outpost of upscale supermarkets with a variety of foodstuffs, plus prepared meals.",
      "poi_long_description": "People say this gourmet grocery store offers a wide selection of fresh produce, ready-made foods, and specialty items, including a popular prime rib sandwich, poke, and \"The Cookie.\" They highlight the high quality of the meats, fish, and bakery items, and the fun, unique, and well-organized layout of the store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-b783-70bf-a4db-08813774b336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-b783-70bf-a4db-08813774b336",
        "storage_key": "property/6767906449164272/019dcf9e-b783-70bf-a4db-08813774b336.webp",
        "width": 640,
        "height": 1280
      },
      "poi_business_url": "https://metropolitan-market.com/locations/proctor/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17820514257045361464&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "metropolitan-market-tacoma",
      "poi_latitude": "47.2695044",
      "poi_longitude": "-122.4898126",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-761-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8e-73f7-8e54-e823199cd190.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8e-73f7-8e54-e823199cd190",
        "storage_key": "property/6767906449164272/019d0815-ed8e-73f7-8e54-e823199cd190.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn5forehUkFQROBP5tUwvT_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fb8c3225-f0c7-49b6-b4a7-71a09d5d0138",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Tacoma Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4502 S Steele St, Tacoma, WA 98409, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "People say this shopping center offers a wide variety of clothing and food options, and has a free indoor play area for children. They also highlight the clean restrooms, the safe and secure environment, and the helpful staff.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d6cdc-a336-715a-9405-78197990af16.webp",
      "poi_featured_image_media": {
        "alt_text": "Coldwater Creek shopping center exterior with multiple stores and a car driving by.",
        "public_id": "019d6cdc-a336-715a-9405-78197990af16",
        "storage_key": "property/6767906449164272/019d6cdc-a336-715a-9405-78197990af16.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.simon.com/mall/tacoma-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6869659206638140388&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tacoma-mall",
      "poi_latitude": "47.2160921",
      "poi_longitude": "-122.4687412",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-475-4565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed8c-72b5-b133-345c68f54996",
        "storage_key": "property/6767906449164272/019d0815-ed8c-72b5-b133-345c68f54996.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEaqbEgIAkVQR5Huow6buVV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8725035d-3394-4ec6-872a-74b8ca937719",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Rankos Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "101 N Tacoma Ave, Tacoma, WA 98403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-ba3a-759b-8881-81e07f4f292a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-ba3a-759b-8881-81e07f4f292a",
        "storage_key": "property/6767906449164272/019dcf9e-ba3a-759b-8881-81e07f4f292a.webp",
        "width": 1192,
        "height": 1280
      },
      "poi_business_url": "https://www.rankospharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11161418288830519213&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rankos-pharmacy",
      "poi_latitude": "47.2648501",
      "poi_longitude": "-122.4485046",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-383-2411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-d060-72d6-9cbd-04db8f75c174.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcf9e-d060-72d6-9cbd-04db8f75c174",
        "storage_key": "property/6767906449164272/019dcf9e-d060-72d6-9cbd-04db8f75c174.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-0Nb6lVkFQRrZdKR8xS5Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f797eb31-af4c-4778-9890-9092b1047833",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Tacoma Dome",
      "poi_type": "Entertainment",
      "poi_address": "2727 E D St, Tacoma, WA 98421, USA",
      "poi_short_description": "One of the world's largest wood domed structures hosts concerts, monster truck shows, and other events.",
      "poi_long_description": "People say this venue is spacious with great acoustics and sound systems, making it ideal for concerts and large events. They also highlight the clean facilities, helpful staff, and easy access to public transportation.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-bd3d-74d1-a806-17afe936510a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-bd3d-74d1-a806-17afe936510a",
        "storage_key": "property/6767906449164272/019dcf9e-bd3d-74d1-a806-17afe936510a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tacomadome.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16187617119274571565&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tacoma-dome",
      "poi_latitude": "47.2365504",
      "poi_longitude": "-122.4268089",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-272-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVVfT_kFQRLZdkGgH4peA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_e6388255-9fc9-4ee6-a632-d736425b85e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "The Grand Cinema",
      "poi_type": "Entertainment",
      "poi_address": "606 Fawcett Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Theater shows independent & foreign movies in keeping with its mission to promote the art of film.",
      "poi_long_description": "Moviegoers say this movie theater offers a unique and enriching experience with a curated selection of films, including Oscar-nominated and independent titles, and delicious coconut oil popcorn. They also highlight the friendly and dedicated staff and volunteers, comfortable seating, and excellent sound system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-bd6c-77fc-9c23-7be2ff23918a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-bd6c-77fc-9c23-7be2ff23918a",
        "storage_key": "property/6767906449164272/019dcf9e-bd6c-77fc-9c23-7be2ff23918a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.grandcinema.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3663088983306244388&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-grand-cinema",
      "poi_latitude": "47.2579114",
      "poi_longitude": "-122.444632",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-572-6062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-d04e-725e-8529-cfec1174f945.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcf9e-d04e-725e-8529-cfec1174f945",
        "storage_key": "property/6767906449164272/019dcf9e-d04e-725e-8529-cfec1174f945.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Umbb6dVkFQRJJGdvgXo1TI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_1c440bb9-c322-4f22-bd0b-e5648a0b9c23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "LeMay - America’s Car Museum",
      "poi_type": "Entertainment",
      "poi_address": "2702 E D St, Tacoma, WA 98421, USA",
      "poi_short_description": "4-story museum on an 8-acre campus displays cars, trucks & motorcycles in historic & tech exhibits.",
      "poi_long_description": "Visitors say this museum features an impressive collection of classic cars, including muscle cars and vintage sedans, with rotating exhibits like the recent Japanese car showcase. They also highlight the friendly and knowledgeable staff, kid-friendly activities like slot car racing, and the convenient free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-cad2-7413-96af-8b0f65ea3347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0815-cad2-7413-96af-8b0f65ea3347",
        "storage_key": "property/6767906449164272/019d0815-cad2-7413-96af-8b0f65ea3347.webp",
        "width": 729,
        "height": 521
      },
      "poi_business_url": "http://www.americascarmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17839745701636681105&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lemay---americas-car-museum",
      "poi_latitude": "47.2357021",
      "poi_longitude": "-122.4303289",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-779-8490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0ed-7731-afc2-7a6c91dfe170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0ed-7731-afc2-7a6c91dfe170",
        "storage_key": "property/6767906449164272/019d0815-f0ed-7731-afc2-7a6c91dfe170.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR-QTHxVkFQRkS1bVTKCk_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2a7c6a36-7426-4efb-b04a-9eb38bb6e12d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Museum of Glass",
      "poi_type": "Entertainment",
      "poi_address": "1801 Dock St, Tacoma, WA 98402, USA",
      "poi_short_description": "Diverse indoor & outdoor glass-art exhibits plus a cone-shaped studio with working artists.",
      "poi_long_description": "People say this art museum showcases beautiful glass art pieces and offers live glass blowing demonstrations. They highlight the mesmerizing experience of watching artists work with molten glass, the diverse range of contemporary glass art, and the unique cone structure of the building. They also like the interactive elements, educational displays, and the Chihuly Bridge of Glass.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d6cdc-f1b1-759a-b7fe-5e148ca0a3d9.webp",
      "poi_featured_image_media": {
        "alt_text": "Waterfront art installation with illuminated glass sculptures at dusk.",
        "public_id": "019d6cdc-f1b1-759a-b7fe-5e148ca0a3d9",
        "storage_key": "property/6767906449164272/019d6cdc-f1b1-759a-b7fe-5e148ca0a3d9.webp",
        "width": 2100,
        "height": 1508
      },
      "poi_business_url": "https://www.museumofglass.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12420455278076938078&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-glass",
      "poi_latitude": "47.24550079999999",
      "poi_longitude": "-122.4340189",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-284-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0ed-7731-afc2-7a6c91dfe170.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0ed-7731-afc2-7a6c91dfe170",
        "storage_key": "property/6767906449164272/019d0815-f0ed-7731-afc2-7a6c91dfe170.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTMDr3dVkFQRXsdm3kRSXqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_0a8419b5-7ef9-4a67-aa11-4395a0d75b8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Tacoma Comedy Club",
      "poi_type": "Entertainment",
      "poi_address": "933 Market St, Tacoma, WA 98402, USA",
      "poi_short_description": "Lively club presenting touring comedians & open-mike nights, plus a full food & drink menu.",
      "poi_long_description": "People say this comedy club offers hilarious shows and a fun atmosphere. They highlight the friendly staff and quick service. They also like the good food and drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-bd5c-766e-90b6-464438b9256f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-bd5c-766e-90b6-464438b9256f",
        "storage_key": "property/6767906449164272/019dcf9e-bd5c-766e-90b6-464438b9256f.webp",
        "width": 1280,
        "height": 1277
      },
      "poi_business_url": "http://www.tacomacomedyclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11243659915445038899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tacoma-comedy-club",
      "poi_latitude": "47.254",
      "poi_longitude": "-122.4413583",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-282-7203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0J1hApVkFQRM29mIx-BCZw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "comedy_club"
    },
    {
      "id": "custom_323859d5-5494-41d6-b143-da7c2ed39a84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Tower Lanes Entertainment Center",
      "poi_type": "Entertainment",
      "poi_address": "6323 6th Ave, Tacoma, WA 98406, USA",
      "poi_short_description": "24-hour entertainment center with indoor mini-golf, bowling & arcade games, plus a bar & restaurant.",
      "poi_long_description": "People say this entertainment center offers fun bowling, an extensive indoor mini-golf course, and an arcade with a variety of games. They also highlight the delicious food and drinks, reasonable prices, and friendly, helpful staff.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c0dc-768c-ae2a-6780387605ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c0dc-768c-ae2a-6780387605ff",
        "storage_key": "property/6767906449164272/019dcf9e-c0dc-768c-ae2a-6780387605ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.towerlanes.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12904568416571522709&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tower-lanes-entertainment-center",
      "poi_latitude": "47.2565397",
      "poi_longitude": "-122.5223031",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-564-8853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL_M6-yyrkVQRlX54gZo8FrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_a312c3e6-c21a-4681-b02b-70e30b93a94f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Point Defiance Zoo & Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "5400 N Pearl St, Tacoma, WA 98407, USA",
      "poi_short_description": "Zoo & aquarium with nearly 300 species, including tigers, meerkats & a landmark red wolf habitat.",
      "poi_long_description": "People say this zoo offers a variety of animals, including polar bears, walruses, and red wolves, as well as two aquariums with sharks and jellyfish. They highlight the annual membership is a good value, and the zoo is family-friendly and stroller-accessible. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d6cdc-e7f7-766e-9e6f-25d50fd0977c.webp",
      "poi_featured_image_media": {
        "alt_text": "Seal swimming underwater.",
        "public_id": "019d6cdc-e7f7-766e-9e6f-25d50fd0977c",
        "storage_key": "property/6767906449164272/019d6cdc-e7f7-766e-9e6f-25d50fd0977c.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.pdza.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7302316362393921577&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "point-defiance-zoo--aquarium",
      "poi_latitude": "47.3049533",
      "poi_longitude": "-122.5216575",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-404-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNVUpO3FTkFQRKSgD0goKV2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_9d230191-c2df-4dc5-a450-c4bb0c79e86f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Freighthouse Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 E D St, Tacoma, WA 98421, USA",
      "poi_short_description": "Shopping mall featuring specialty retailers & local food vendors in a circa-1909 railroad building.",
      "poi_long_description": "People say this food court offers a wide variety of delicious food options, including diverse ethnic cuisines, and has unique shops. They also highlight the convenient location for travelers using the Amtrak station.\n\nSome reviews mention many shops can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c27e-70fc-86c2-9721c1bc571b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c27e-70fc-86c2-9721c1bc571b",
        "storage_key": "property/6767906449164272/019dcf9e-c27e-70fc-86c2-9721c1bc571b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11572388962743136945&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "freighthouse-square",
      "poi_latitude": "47.2397873",
      "poi_longitude": "-122.4267078",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1Jx1X5VkFQRsbL0znJimaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_ad79c3d9-52ab-4ae5-854d-fa901afcd02c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "The Drop Pickleball Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2360 Fawcett Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Pickleball center with 7 indoor and 1 outdoor court hosting open play, leagues, and tournaments.",
      "poi_long_description": "People say this pickleball facility offers well-maintained courts and quality equipment, suitable for all skill levels. They also highlight the friendly and welcoming staff, who are helpful and accommodating. Guests mention the positive atmosphere and community feel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c263-7038-95d6-90bb9d0a3d86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c263-7038-95d6-90bb9d0a3d86",
        "storage_key": "property/6767906449164272/019dcf9e-c263-7038-95d6-90bb9d0a3d86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thedroppbc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14848072864777613836&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-drop-pickleball-club",
      "poi_latitude": "47.2387527",
      "poi_longitude": "-122.4401108",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-331-3194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_XwQDB1VkFQRDLIvIJrzDs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_c15ed9b6-91d0-47a7-8f60-fc318d1462f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Emerald Queen Casino and Hotel",
      "poi_type": "Entertainment",
      "poi_address": "2920 E R St, Tacoma, WA 98404, USA",
      "poi_short_description": "Straightforward quarters in a vibrant hotel offering a casino, 4 restaurants & entertainment.",
      "poi_long_description": "People say this hotel offers a casino, bars, and a sports book, as well as a variety of slot machines and table games. They also highlight the friendly and helpful staff, the fun and lively atmosphere, and the convenient covered parking.\n\nOther reviews mention the payouts can be low.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c37d-740f-b6a6-b5813c9583d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c37d-740f-b6a6-b5813c9583d8",
        "storage_key": "property/6767906449164272/019dcf9e-c37d-740f-b6a6-b5813c9583d8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://emeraldqueen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7334719434875167079&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "emerald-queen-casino-and-hotel",
      "poi_latitude": "47.2378063",
      "poi_longitude": "-122.4081792",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-594-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-d067-7139-8705-73fa28c22b66.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dcf9e-d067-7139-8705-73fa28c22b66",
        "storage_key": "property/6767906449164272/019dcf9e-d067-7139-8705-73fa28c22b66.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJIQXeTw__kFQRZ2HjCncoymU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_e743bbf7-381a-4fbd-806c-3cb4ca129a7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Cheney Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2502 S Tyler St, Tacoma, WA 98405, USA",
      "poi_short_description": "Minor-league baseball stadium, home to the Tacoma Rainiers, with a Mt. Rainier view & luxury suites.",
      "poi_long_description": "People say this stadium offers a fun minor league baseball experience with exciting games and fireworks. They highlight the clean facilities, abundant food and drink options, and the great value, especially for families. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d7911-0b89-713a-a484-629faaa74c53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-0b89-713a-a484-629faaa74c53",
        "storage_key": "property/6767906449164272/019d7911-0b89-713a-a484-629faaa74c53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milb.com/tacoma/ballpark/cheney-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=4065610704513121264&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cheney-stadium",
      "poi_latitude": "47.2378167",
      "poi_longitude": "-122.4977467",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-752-7707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0e3-770d-9878-e906f232c1b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0e3-770d-9878-e906f232c1b0",
        "storage_key": "property/6767906449164272/019d0815-f0e3-770d-9878-e906f232c1b0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGaxAR8uqkVQR8LuHLWXzazg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b139fc92-7918-48bf-a54a-8f4e3b9d0200",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "University of Washington Tacoma",
      "poi_type": "Education",
      "poi_address": "1900 Commerce St, Tacoma, WA 98402, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-c0b8-76df-90ed-0f0a4e3bbaa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0815-c0b8-76df-90ed-0f0a4e3bbaa3",
        "storage_key": "property/6767906449164272/019d0815-c0b8-76df-90ed-0f0a4e3bbaa3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tacoma.uw.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8015147170715330239&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-washington-tacoma",
      "poi_latitude": "47.2454407",
      "poi_longitude": "-122.4385162",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-692-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed71-7790-a4c9-9bb5131e435f",
        "storage_key": "property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWzChLXdVkFQRv-b2vOKFO28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6dfb09ad-babb-433e-a6ed-279577ca4dd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "University of Puget Sound",
      "poi_type": "Education",
      "poi_address": "1500 N Warner St, Tacoma, WA 98416, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d7911-0a7a-77ac-895b-68e66f522a0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-0a7a-77ac-895b-68e66f522a0d",
        "storage_key": "property/6767906449164272/019d7911-0a7a-77ac-895b-68e66f522a0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pugetsound.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5089139173331474544&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-puget-sound",
      "poi_latitude": "47.2617495",
      "poi_longitude": "-122.4814442",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-879-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed71-7790-a4c9-9bb5131e435f",
        "storage_key": "property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVVVlQpVkFQRcJjyXh1BoEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f11e7917-3aa7-4e24-b327-2b9c025da26d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Pacific Lutheran University",
      "poi_type": "Education",
      "poi_address": "12180 Park Ave. S, Tacoma, WA 98447, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c73a-732f-8d4a-26f2aeca0002.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c73a-732f-8d4a-26f2aeca0002",
        "storage_key": "property/6767906449164272/019dcf9e-c73a-732f-8d4a-26f2aeca0002.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://www.plu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4175111740689180711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pacific-lutheran-university",
      "poi_latitude": "47.14519310000001",
      "poi_longitude": "-122.4436669",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-535-7411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed71-7790-a4c9-9bb5131e435f",
        "storage_key": "property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7f9NLYEBkVQRJ2hX6QH68Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cd5b7d3d-b489-430b-94e8-d9fe5b6c3960",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Tacoma Community College",
      "poi_type": "Education",
      "poi_address": "6501 S 19th St, Tacoma, WA 98466, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-c0ba-77a9-a077-23b463e34024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0815-c0ba-77a9-a077-23b463e34024",
        "storage_key": "property/6767906449164272/019d0815-c0ba-77a9-a077-23b463e34024.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.tacomacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=602570984518978676&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tacoma-community-college",
      "poi_latitude": "47.2462328",
      "poi_longitude": "-122.5219935",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-566-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed71-7790-a4c9-9bb5131e435f",
        "storage_key": "property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbz1it9eqkVQRdAw2LB7DXAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_24c5b6cd-0e6b-410c-80e1-4355cfa71f7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Stadium High School",
      "poi_type": "Education",
      "poi_address": "111 N E St, Tacoma, WA 98403, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c761-70b9-9967-f7adf25ebfb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c761-70b9-9967-f7adf25ebfb8",
        "storage_key": "property/6767906449164272/019dcf9e-c761-70b9-9967-f7adf25ebfb8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stadium.tacomaschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10283808825010498266&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stadium-high-school",
      "poi_latitude": "47.2660086",
      "poi_longitude": "-122.4484925",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-571-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-ed71-7790-a4c9-9bb5131e435f",
        "storage_key": "property/6767906449164272/019d0815-ed71-7790-a4c9-9bb5131e435f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQW6d5KtVkFQR2irH8KNtt44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c9cf084e-1ac6-4dd9-9309-f38495d5ca0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Wright Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501 S I St, Tacoma, WA 98405, USA",
      "poi_short_description": "Greenspace with a vast collection of trees, plus a trail, playgrounds, sport courts & picnic areas.",
      "poi_long_description": "People say this park features a wide variety of old-growth trees, walking paths, and a beautiful botanical conservatory. Visitors also highlight the clean and well-maintained restrooms, along with family-friendly amenities like a playground and splash pad. They also mention the peaceful atmosphere, making it a relaxing place to enjoy nature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d7911-23e6-74ce-889f-9936bb9b18fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-23e6-74ce-889f-9936bb9b18fc",
        "storage_key": "property/6767906449164272/019d7911-23e6-74ce-889f-9936bb9b18fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metroparkstacoma.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18017825162376901426&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wright-park",
      "poi_latitude": "47.2594789",
      "poi_longitude": "-122.4489414",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-305-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f472-7605-b6f4-00a3e8a497d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f472-7605-b6f4-00a3e8a497d5",
        "storage_key": "property/6767906449164272/019d0815-f472-7605-b6f4-00a3e8a497d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJocxN_wdVkFQRMvORzIUsDPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3fba2a8b-2bcc-4204-8aaf-d0285ca66b9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Ruston Way Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Ruston Way, Tacoma, WA 98407, USA",
      "poi_short_description": "Waterside park featuring paved trails with beach access, picnicking, and scenic views.",
      "poi_long_description": "People say this park offers beautiful views of the water and a paved path for walking. They highlight the opportunity to see blue herons and enjoy a scenic walk along the Foss Waterway and Sound. They also like the nearby hangout spot. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c9c9-752c-8e0a-066cb21de09d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c9c9-752c-8e0a-066cb21de09d",
        "storage_key": "property/6767906449164272/019dcf9e-c9c9-752c-8e0a-066cb21de09d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.metroparkstacoma.org/ruston-way/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8866451867136030072&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ruston-way-park",
      "poi_latitude": "47.2833404",
      "poi_longitude": "-122.4827414",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-305-1030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f472-7605-b6f4-00a3e8a497d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f472-7605-b6f4-00a3e8a497d5",
        "storage_key": "property/6767906449164272/019d0815-f472-7605-b6f4-00a3e8a497d5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSpbB4tUkFQRePW9Jv_2C3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a18f3cc1-580b-439b-a82f-dce04425a413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Chihuly Bridge of Glass",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bridge of Glass, Tacoma, WA 98402, USA",
      "poi_short_description": "Pedestrian bridge decorated with colorful glass installations by prominent artist Dale Chihuly.",
      "poi_long_description": "Visitors say this pedestrian bridge features breathtaking Chihuly glass installations, including the Seaform Pavilion with its colorful marine-life inspired glass ceiling. They also highlight that it's a great place to enjoy a short walk, appreciate the art and architecture, and take in the views of the city and waterfront.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c9c0-7603-8a3c-ba16df647f86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c9c0-7603-8a3c-ba16df647f86",
        "storage_key": "property/6767906449164272/019dcf9e-c9c0-7603-8a3c-ba16df647f86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.museumofglass.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17930865792443176084&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chihuly-bridge-of-glass",
      "poi_latitude": "47.2456664",
      "poi_longitude": "-122.4345766",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 866-468-7386",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzmC5HZVkFQRlFTHuW871_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "custom_c0bb3f90-34e4-45dc-a599-b418e12d43dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Thea Foss Waterway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Thea Foss Waterway, Washington, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c8c3-77ca-99b6-b2cf76ad18d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c8c3-77ca-99b6-b2cf76ad18d1",
        "storage_key": "property/6767906449164272/019dcf9e-c8c3-77ca-99b6-b2cf76ad18d1.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3845839453401368083&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thea-foss-waterway",
      "poi_latitude": "47.2537626",
      "poi_longitude": "-122.4323147",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0815-f0b1-77b4-953a-bd682338f8d1",
        "storage_key": "property/6767906449164272/019d0815-f0b1-77b4-953a-bd682338f8d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv_NjoKVVkFQRE8YrU5sqXzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "natural_feature"
    },
    {
      "id": "custom_3968894f-898b-4338-940d-f348f02208a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "poi_name": "Chambers Bay Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6320 Grandview Dr W, University Place, WA 98467, USA",
      "poi_short_description": "This public course designed by renowned golf architect Robert Trent Jones Jr has hosted the US Open.",
      "poi_long_description": "People say this public golf course offers breathtaking views of the water, islands, and a long train, and is perfect for sports, picnics, and family gatherings. They highlight the challenging and scenic walking trails, and the opportunity to play golf. They also like the friendly staff and the top-notch pro shop, clubhouse, and club rentals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019dcf9e-c9eb-7099-bd4d-cd80abd96b6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dcf9e-c9eb-7099-bd4d-cd80abd96b6b",
        "storage_key": "property/6767906449164272/019dcf9e-c9eb-7099-bd4d-cd80abd96b6b.webp",
        "width": 1280,
        "height": 320
      },
      "poi_business_url": "http://www.chambersbaygolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16448961189655971989&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chambers-bay-golf-course",
      "poi_latitude": "47.2003276",
      "poi_longitude": "-122.5707511",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 253-460-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d6ce0-843a-75eb-93df-b81623040320.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person playing soccer.",
        "public_id": "019d6ce0-843a-75eb-93df-b81623040320",
        "storage_key": "property/6767906449164272/019d6ce0-843a-75eb-93df-b81623040320.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQPwfHOqkVQRlYihOQ1zRuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    }
  ],
  "office_hours": [
    {
      "id": "ec_7a16fe4c1dadb5ffc7d8d7f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2e28a9772d2fb38d3df25b17",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_35c1b8299dbbf1a6122e1b6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a37745b77a398f63dc66c604",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_89be6bf4985faf88d4f40a41",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_aaede8d3caf79d0240d0f5ec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_debd05fcc8c3c01241ef8c63",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "rating": "5",
      "name": "Arch Beauty Collective",
      "text": "I have lived here 9 months and extended my lease because I love it so much! Everyone is friendly and the amenities are incredible. It’s close to the freeway, coffee shops, the waterfront, there’s so much to love! I love the sense of community they build with their monthly events. I’m very happy with my decision to move here 🤍",
      "date": "2025-07-19",
      "title": "false"
    },
    {
      "id": "ec_44b5b1f82dd7c2c5195c7216",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "rating": "5",
      "name": "Lynette R",
      "text": "I walked into the Lex and was welcomed by Nathan. He was very pleasant and professional. I was given a tour by Sara who was also very pleasant and patient with me. I asked to see several apartments and Sara was very accommodating. It's been a month since I moved in and the service here at the Lex is still top notch. Just today Nathan was busy with a move in but took time to help me with a print out needed for fed ex, so thankful. Mario is amazing and always willing to help. Alex from maintenance is the best. I had an issue with my garbage disposal and Alex was very helpful.  Thank you, Lex staff for caring about your residents. :)",
      "date": "2023-11-27",
      "title": "false"
    },
    {
      "id": "ec_d1db5439501156dc866ffa7b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "rating": "5",
      "name": "Emily Love",
      "text": "Living in Tacoma and at The Lex this past year has been such a great experience, and we were so sad to leave. We loved the apartment and all the amenities, especially the rooftop, such a great place to enjoy the views, hang out, grill a meal, watch something on one of the multiple TV’s or sit around the fire pits. From the day we walked in, the staff had been so amazing, especially Mario. Because the complex had just opened, he showed us a bunch of different units because we had a hard time picking one. We liked another building near by, but Mario and his team sealed the deal for us. We loved the energy there, and would definitely recommend The Lex to anyone looking for a new place to call home.",
      "date": "2024-03-28",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f14a8f21-5e08-4d6b-bb3b-4590126c56c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d6de3-9b07-75c9-94d4-e2b14343b09e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d6de3-9b07-75c9-94d4-e2b14343b09e",
        "storage_key": "property/6767906449164272/019d6de3-9b07-75c9-94d4-e2b14343b09e.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "The Lex",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?id=pano-22990852&tour=6335f48367602324b34e5765"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a3127-3daf-76db-8f5a-eb205e7c533f",
      "lead_source": "LANDING_PAGE",
      "name": "The Lex landing page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272"
    },
    {
      "lead_collector_id": "019a3127-3e4a-74aa-b8c3-3bbf6f2758fe",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Lex property website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-sky-lounge-tacoma",
      "search_query": "apartments with sky lounge tacoma",
      "category": "Amenity",
      "h1_title": "Apartments with Sky Lounge in Tacoma",
      "h2_subtitle": "Discover the luxury of Tacoma's apartments with sky lounges. Experience unparalleled views and modern amenities at The Lex.",
      "page_copy": "Searching for apartments with sky lounge in Tacoma? Look no further than The Lex. Our stunning sky lounge offers breathtaking views of Tacoma, making it the perfect spot to unwind after a long day. Whether you're looking for a studio, one-bedroom, or two-bedroom apartment, The Lex provides the ideal setting for a vibrant lifestyle. Enjoy elegant features such as quartz counters and soft-close cabinets, providing the comfort and luxury you deserve.\n\nThe Lex is more than just a place to live; it's a community designed with your lifestyle in mind. Our sky lounge is a community favorite, offering a unique space for residents to relax and socialize. Conveniently located in Tacoma, The Lex provides easy access to shopping, dining, and entertainment. Explore our available units or schedule a visit today. See firsthand why The Lex is the premier choice for those seeking apartments with sky lounge in Tacoma.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Sky Lounge in Tacoma",
      "seo_description": "Explore Tacoma's premier apartments with a sky lounge at The Lex, offering modern amenities and stunning views. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "modern-apartments-quartz-counters-tacoma",
      "search_query": "modern apartments with quartz counters tacoma",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Quartz Counters Tacoma",
      "h2_subtitle": "Explore Tacoma's modern apartments featuring elegant quartz counters. Experience luxury living at The Lex today.",
      "page_copy": "If you're searching for modern apartments with quartz counters in Tacoma, The Lex stands out as a premier choice. Each apartment, whether a studio, one-bedroom, or two-bedroom, is outfitted with elegant quartz countertops, offering both style and functionality. These sleek surfaces are not only beautiful but also durable, ideal for contemporary living.\n\nLocated in the heart of Tacoma, The Lex combines top-tier amenities with a vibrant community. In addition to quartz counters, you'll find soft-close cabinets and a beautiful sky lounge perfect for relaxation. Enjoy the perfect blend of modern design and convenient city living. Discover what sets The Lex apart when you schedule a tour or browse our available units today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Quartz Counters Tacoma",
      "seo_description": "Discover Tacoma's modern apartments with quartz counters at The Lex. Enjoy stylish interiors and vibrant community living. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "luxury-living-soft-close-cabinets-pierce-county",
      "search_query": "luxury living with soft close cabinets pierce county",
      "category": "Amenity",
      "h1_title": "Luxury Living with Soft Close Cabinets",
      "h2_subtitle": "Experience luxury living in Pierce County with soft close cabinets at The Lex. Discover modern elegance and premium amenities.",
      "page_copy": "For those seeking luxury living with soft close cabinets in Pierce County, The Lex offers an unmatched experience. Each of our modern studios, one-bedroom, and two-bedroom apartments feature these sophisticated cabinets, providing a seamless and quiet solution to everyday use. Beyond their functionality, these cabinets add a touch of refined elegance to your kitchen and bathroom spaces.\n\nLocated in the vibrant heart of Tacoma, our apartments are designed with high-end finishes and top-of-the-line amenities, including a sky lounge with stunning views. At The Lex, the focus is on quality and contemporary living, making it an ideal choice for individuals desiring a luxurious lifestyle. Contact us today to learn more about our available units and find your new home in Pierce County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Living with Soft Close Cabinets",
      "seo_description": "Embrace luxury living with soft close cabinets in Pierce County at The Lex. Modern amenities and design await. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-near-downtown-tacoma-zip-98402",
      "search_query": "apartments near downtown tacoma zip 98402",
      "category": "Amenity",
      "h1_title": "Apartments Near Downtown Tacoma 98402",
      "h2_subtitle": "Find premium apartments near downtown Tacoma in the 98402 area. Enjoy modern living at The Lex, just steps from city attractions.",
      "page_copy": "Discover the convenience of living in apartments near downtown Tacoma, zip code 98402. The Lex offers a perfect location just a short distance from Tacoma's vibrant downtown area. Our modern apartments, ranging from studios to spacious two-bedroom layouts, combine elegance with accessibility, making your urban living experience both luxurious and convenient.\n\nAt The Lex, residents enjoy not only a prime location but also top-tier amenities like our stunning sky lounge, quartz countertops, and soft close cabinets. Situated in the bustling 98402 zip code, The Lex provides quick access to an array of dining, shopping, and entertainment options. Experience the best of city living by scheduling a tour today and explore the lifestyle awaiting you at The Lex.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Downtown Tacoma 98402",
      "seo_description": "Explore modern living at The Lex, offering apartments near downtown Tacoma in the 98402 area. Premium amenities and prime location await. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "best-apartment-amenities-tacoma-wa",
      "search_query": "best apartment amenities in tacoma wa",
      "category": "Amenity",
      "h1_title": "Best Apartment Amenities in Tacoma, WA",
      "h2_subtitle": "Discover the best apartment amenities in Tacoma, WA at The Lex, where luxury meets convenience.",
      "page_copy": "For those seeking the best apartment amenities in Tacoma, WA, The Lex provides an array of features designed to enhance your lifestyle. Located in the heart of Tacoma, our community offers modern studios and spacious one- and two-bedroom apartments equipped with luxury finishes like quartz counters and soft-close cabinets that blend functionality with style.\n\nOur property amenities include a stunning sky lounge that offers breathtaking views and serves as an ideal space for relaxation and socializing. The Lex ensures a vibrant living experience with conveniences aimed at the discerning resident. Make The Lex your home and enjoy access to the best of Tacoma living. Schedule a tour or explore our availability today and elevate your lifestyle with our premium amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Best Apartment Amenities in Tacoma, WA",
      "seo_description": "Explore The Lex for the best apartment amenities in Tacoma, WA. Enjoy luxury living with modern features and a sky lounge. Contact us for a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "studio-apartments-tacoma",
      "search_query": "studio apartments in Tacoma",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Tacoma at The Lex",
      "h2_subtitle": "Explore stylish studio apartments in Tacoma at The Lex. Enjoy modern amenities and a prime location in the heart of the city.",
      "page_copy": "Experience the perfect blend of comfort and style in studio apartments in Tacoma at The Lex. Our studios are thoughtfully designed to maximize space and light, offering a modern aesthetic with luxury finishes like quartz countertops and soft-close cabinets. Situated in Tacoma, our location provides residents easy access to vibrant city life while enjoying the tranquility of a refined living space.\n\nAt The Lex, you’ll enjoy more than just a home; you gain a lifestyle enriched with top-tier amenities. The sky lounge offers a stunning retreat with breathtaking views, ideal for relaxing or socializing with friends. Whether you're a young professional or simply seeking a compact and chic living space, our studio apartments provide everything you need. Schedule a visit today and envision life at The Lex, where modern living meets urban convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Tacoma at The Lex",
      "seo_description": "Find your perfect studio apartment in Tacoma at The Lex. Modern design, luxury finishes, and prime location await. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-pierce-county",
      "search_query": "one bedroom apartments Pierce County",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Pierce County",
      "h2_subtitle": "Explore elegant one bedroom apartments in Pierce County at The Lex. Offering luxury finishes and modern amenities for a comfortable lifestyle.",
      "page_copy": "The Lex in Pierce County offers one bedroom apartments tailored for sophisticated living. These thoughtfully designed spaces feature luxurious finishes such as quartz countertops and soft-close cabinets. Our one bedroom units are perfect for those who appreciate a balance of elegance and functionality, nestled in the heart of thriving Tacoma.\n\nBeyond the comfort of your apartment, The Lex provides residents with top-tier amenities, including a beautiful sky lounge ideal for relaxation or entertainment. Being located in Pierce County ensures you are never far from the excitement of Tacoma’s dining, shopping, and cultural amenities. If you're seeking a well-rounded living experience, our one bedroom apartments offer the perfect solution. Schedule a tour today and discover why The Lex is the ideal choice for modern living in Pierce County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Pierce County",
      "seo_description": "Discover one bedroom apartments in Pierce County at The Lex, featuring luxury finishes and top amenities. Schedule your visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-98402",
      "search_query": "two bedroom apartments near 98402",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 98402",
      "h2_subtitle": "Discover spacious two bedroom apartments near 98402 at The Lex. Enjoy luxury living in the heart of Tacoma with modern amenities.",
      "page_copy": "If you're searching for two bedroom apartments near 98402, look no further than The Lex in Tacoma. Our two bedroom units are designed to provide ample space and luxury, featuring high-end finishes like quartz countertops and soft-close cabinets. Each apartment is crafted to offer both functionality and elegance, catering to diverse lifestyle needs.\n\nLocated within Tacoma's vibrant center, The Lex provides quick access to the city's best attractions while offering a peaceful home environment. Residents can unwind in our magnificent sky lounge, complete with picturesque views ideal for relaxation or entertaining. If a combination of prime location and premium amenities is what you seek, visit The Lex. Schedule a tour today and see why our two bedroom apartments are a top choice near the 98402 area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 98402",
      "seo_description": "Find spacious two bedroom apartments near 98402 at The Lex. Luxury amenities and a central Tacoma location await. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-near-tacoma-community-college",
      "search_query": "apartments near tacoma community college",
      "category": "School",
      "h1_title": "Apartments Near Tacoma Community College",
      "h2_subtitle": "Explore modern apartments near Tacoma Community College at The Lex. Enjoy convenient living with luxurious amenities just minutes away.",
      "page_copy": "Find your ideal home at The Lex, offering apartments near Tacoma Community College. With a range of studio, one, and two-bedroom options, our community is perfect for students and faculty seeking convenience without sacrificing comfort. Each apartment features luxurious quartz countertops and soft-close cabinets, creating a stylish and functional living space.\n\nLocated in the heart of Tacoma, The Lex provides easy access to public transportation and local attractions, ensuring you can balance academics with vibrant city life. Residents also enjoy exclusive access to our stunning sky lounge, perfect for unwinding after a long day. If you want to be near Tacoma Community College with a touch of elegance, The Lex is the place to be. Schedule a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tacoma Community College",
      "seo_description": "Discover convenient, modern apartments near Tacoma Community College at The Lex. Comfortable living with luxurious amenities awaits. Schedule a tour!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-close-to-university-of-washington-tacoma",
      "search_query": "apartments close to university of washington tacoma",
      "category": "School",
      "h1_title": "Apartments Close to UW Tacoma",
      "h2_subtitle": "Find premium apartments close to the University of Washington Tacoma at The Lex. Experience unparalleled comfort with our modern amenities.",
      "page_copy": "The Lex offers an excellent choice in apartments close to the University of Washington Tacoma. For students and faculty seeking convenience, our contemporary studio, one, and two-bedroom apartments offer the perfect blend of style and comfort. Each unit includes luxurious features such as quartz countertops and soft-close cabinets, ensuring a sophisticated living experience.\n\nLocated right in the heart of Tacoma, The Lex provides residents with easy access to the campus and the city's vibrant culture. Enjoy beautiful views and relaxation opportunities in our sky lounge, adding a touch of luxury to your day. If proximity to the University of Washington Tacoma and modern living are your priorities, look no further than The Lex. Schedule a tour today and secure your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to UW Tacoma",
      "seo_description": "Live near UW Tacoma in style at The Lex. Discover modern apartments with luxury amenities and an excellent location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-by-university-of-puget-sound-pierce-county",
      "search_query": "apartments by university of puget sound pierce county",
      "category": "School",
      "h1_title": "Apartments by University of Puget Sound",
      "h2_subtitle": "Discover exceptional apartments by the University of Puget Sound in Pierce County at The Lex. Enjoy modern living at its finest.",
      "page_copy": "Situated in Tacoma, The Lex offers prime apartments by the University of Puget Sound, perfect for students and faculty seeking convenient, luxurious living. Our studio, one, and two-bedroom apartments are designed with premium features like quartz countertops and soft-close cabinets, creating an elegant and comfortable atmosphere.\n\nLocated within a short distance of the University of Puget Sound, residents enjoy both easy access to campus and the dynamic life of Pierce County. With our stunning sky lounge, unwind and take in spectacular views after a busy day. The Lex combines the perfect location with upscale amenities, making it the ideal choice for those wanting a home near the university. Visit us today to explore your new living space.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by University of Puget Sound",
      "seo_description": "Find modern apartments by the University of Puget Sound in Pierce County at The Lex. Enjoy luxurious amenities and prime location. Discover today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-near-st-joseph-medical-center-tacoma",
      "search_query": "apartments near St. Joseph Medical Center Tacoma",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Joseph Medical Center",
      "h2_subtitle": "Located near St. Joseph Medical Center in Tacoma, The Lex offers modern apartments with luxurious amenities. Experience the perfect blend of style and convenience.",
      "page_copy": "The Lex in Tacoma provides luxurious apartments near St. Joseph Medical Center, ideal for healthcare professionals and medical students. Featuring studio, one, and two-bedroom options, each apartment is appointed with elegant quartz countertops and soft-close cabinets, ensuring a high standard of living.\n\nOur central location means residents are just a short distance from St. Joseph Medical Center, facilitating easy commutes and allowing more time for relaxation in our exquisite sky lounge. Embrace a vibrant lifestyle with the convenience of nearby shopping, dining, and entertainment, making The Lex the perfect choice for those seeking apartments near St. Joseph Medical Center. Schedule your tour and discover your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Joseph Medical Center",
      "seo_description": "Discover modern apartments near St. Joseph Medical Center in Tacoma at The Lex. Experience convenience and luxury amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-close-to-multicare-tacoma-general-hospital-98402",
      "search_query": "apartments close to MultiCare Tacoma General Hospital 98402",
      "category": "Hospital",
      "h1_title": "Apartments Close to MultiCare Tacoma General",
      "h2_subtitle": "Find your perfect home near MultiCare Tacoma General Hospital in the 98402 area at The Lex. A blend of luxury and convenience awaits.",
      "page_copy": "Offering premium living options, The Lex features apartments close to MultiCare Tacoma General Hospital, situated conveniently in the 98402 zip code. Choose from our stylish studios, and one- or two-bedroom apartments, all enhanced with high-end finishes like quartz countertops and soft-close cabinets, elevating your everyday living experience.\n\nPerfectly positioned for healthcare professionals and visitors alike, The Lex provides seamless access to Tacoma General Hospital while offering an array of modern amenities. Relax and take in the breathtaking views from our sky lounge after a busy day. The Lex combines sophistication with a prime location, making it the top choice for those seeking a home near MultiCare Tacoma General Hospital. Contact us to schedule a tour and see your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to MultiCare Tacoma General",
      "seo_description": "Explore stylish apartments near MultiCare Tacoma General in the 98402 area. The Lex offers luxury and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-near-point-defiance-park-tacoma",
      "search_query": "apartments near point defiance park tacoma",
      "category": "Park",
      "h1_title": "Apartments Near Point Defiance Park",
      "h2_subtitle": "Discover luxurious apartments near Point Defiance Park at The Lex in Tacoma. Enjoy nature and modern amenities in one location.",
      "page_copy": "The Lex offers a perfect blend of nature and modern living with apartments near Point Defiance Park in Tacoma. Our studio, one-, and two-bedroom units are adorned with quartz countertops and soft-close cabinets, ensuring a stylish and comfortable home environment.\n\nBeing close to Point Defiance Park allows residents to indulge in the natural beauty and recreational opportunities the park offers. Whether it's a leisurely stroll or an active day outdoors, you'll love the proximity. After exploring, return to the serenity of our sky lounge and enjoy the panoramic views. The Lex combines luxury with an unbeatable location, making it the preferred choice for those wanting easy access to both nature and a vibrant lifestyle. Book a tour and discover your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Point Defiance Park",
      "seo_description": "Live near nature with luxurious apartments by Point Defiance Park in Tacoma. Experience The Lex's modern amenities and prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "tacoma-apartments-close-to-dash-point-state-park",
      "search_query": "tacoma apartments close to dash point state park",
      "category": "Park",
      "h1_title": "Tacoma Apartments Close to Dash Point Park",
      "h2_subtitle": "Explore modern living in Tacoma with apartments close to Dash Point State Park. The Lex offers a lifestyle of convenience and luxury.",
      "page_copy": "At The Lex, enjoy living in modern Tacoma apartments close to Dash Point State Park, combining outdoor adventure with urban comforts. Choose from our thoughtfully designed studio, one-, and two-bedroom apartments, each equipped with quartz counters and soft-close cabinetry, offering a modern touch to your daily life.\n\nLiving near Dash Point State Park means you're always ready for a spontaneous nature excursion, perfect for hiking and exploring scenic trails whenever the mood strikes. After a day at the park, unwind at our sophisticated sky lounge with breathtaking views. The Lex blends location, luxury, and lifestyle into one cohesive experience, making it ideal for those seeking Tacoma apartments close to Dash Point State Park. Reach out today to explore your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tacoma Apartments Near Dash Point Park",
      "seo_description": "Discover luxury apartments in Tacoma near Dash Point State Park at The Lex. Enjoy outdoor adventures and modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "the-lex-tacoma-apartments-by-dune-peninsula",
      "search_query": "the lex tacoma apartments by dune peninsula at point defiance",
      "category": "Park",
      "h1_title": "The Lex Tacoma Apartments by Dune Peninsula",
      "h2_subtitle": "Experience premier living at The Lex Tacoma Apartments, located near the beautiful Dune Peninsula at Point Defiance.",
      "page_copy": "Welcome to The Lex, Tacoma's premier apartments, conveniently located by the picturesque Dune Peninsula at Point Defiance. Experience luxury living in our modern studios, as well as spacious one- and two-bedroom apartments. Each unit comes with high-end finishes like quartz countertops and soft-close cabinets, offering an elegant and inviting home.\n\nSituated close to Dune Peninsula, The Lex provides easy access to captivating outdoor spaces and stunning waterfront views. After a day of exploration, residents can relax in our sky lounge, which offers panoramic views of Tacoma's skyline. This perfect harmony of location and luxury makes The Lex the ideal spot for those seeking Tacoma apartments near the Dune Peninsula. Schedule a visit to see why our community is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Lex Tacoma Apartments by Dune Peninsula",
      "seo_description": "Discover luxury living at The Lex near Dune Peninsula at Point Defiance. Elegant apartments with modern amenities await you. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "pierce-county-apartments-near-wright-park",
      "search_query": "pierce county apartments near wright park",
      "category": "Park",
      "h1_title": "Pierce County Apartments Near Wright Park",
      "h2_subtitle": "Discover top-tier Pierce County apartments near Wright Park at The Lex. Enjoy proximity to nature and luxurious amenities.",
      "page_copy": "Located in the heart of Pierce County, The Lex offers exceptional apartments near Wright Park, a charming urban escape in Tacoma known for its lush greenery and serene walking paths. Our property features beautifully designed studio, one-, and two-bedroom apartments enhanced with sophisticated quartz countertops and the convenience of soft-close cabinetry.\n\nLiving near Wright Park provides a unique balance of tranquility and urban convenience. Enjoy leisurely walks or refreshing morning jogs right at your doorstep. After a day outdoors, retreat to your comfortable apartment or relax in the stunning sky lounge with expansive views. The Lex offers a harmonious blend of nature access and modern living, making it a preferred choice for those looking to reside in Pierce County. Book a tour today and explore your future home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pierce County Apartments Near Wright Park",
      "seo_description": "Live in luxury at Pierce County apartments near Wright Park. The Lex offers modern living with access to nature. Contact us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-near-wapato-park-in-tacoma",
      "search_query": "apartments near wapato park in tacoma",
      "category": "Park",
      "h1_title": "Apartments Near Wapato Park in Tacoma",
      "h2_subtitle": "Explore The Lex, offering apartments near Wapato Park in Tacoma. Enjoy modern amenities and natural beauty combined.",
      "page_copy": "Discover The Lex, where sophisticated living meets natural beauty, with our apartments near Wapato Park in Tacoma. Choose from elegantly designed studios, as well as spacious one- and two-bedroom units, all featuring contemporary quartz countertops and high-quality soft-close cabinetry.\n\nWapato Park offers picturesque landscapes and tranquil water views, making it an ideal spot for leisurely strolls and picnics. Reside in our community and enjoy convenient access to this urban oasis. After a day of exploration, retreat to The Lex's stunning sky lounge, where you can unwind and take in the panoramic views. Our location and style offer an unmatched living experience. Discover why The Lex is the perfect choice for those seeking apartments near Wapato Park in Tacoma. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wapato Park, Tacoma",
      "seo_description": "Find luxury living at The Lex, offering apartments near Wapato Park in Tacoma. Enjoy modern amenities and nature. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-near-tacoma-dome-wa",
      "search_query": "apartments near Tacoma Dome WA",
      "category": "Transit",
      "h1_title": "Apartments Near Tacoma Dome, WA",
      "h2_subtitle": "The Lex offers modern apartments near Tacoma Dome, WA. Experience luxury living and vibrant city life nearby.",
      "page_copy": "The Lex is ideally located for those seeking apartments near Tacoma Dome, WA. Our community offers contemporary studios and spacious one- and two-bedroom apartments, each thoughtfully designed with elegant quartz countertops and soft-close cabinetry for a touch of luxury in everyday living.\n\nJust minutes from the Tacoma Dome, residents at The Lex can easily enjoy a variety of concerts, events, and entertainment options. After a lively evening at the Dome, retreat to our serene community, unwind in the sky lounge, and take in the breathtaking views of Tacoma's skyline. Combining proximity to vibrant city life and luxurious amenities, The Lex provides a premier living experience near Tacoma Dome. Plan your visit today and see what makes The Lex the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tacoma Dome, WA",
      "seo_description": "Live near excitement at The Lex, offering elegant apartments close to Tacoma Dome, WA. Explore amenities and vibrant city life. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164272",
      "source": "generator",
      "page_item_url": "apartments-close-to-union-station-tacoma",
      "search_query": "apartments close to Union Station Tacoma",
      "category": "Transit",
      "h1_title": "Apartments Close to Union Station Tacoma",
      "h2_subtitle": "Experience The Lex, home to luxurious apartments close to Union Station Tacoma. Convenience meets style in our prime location.",
      "page_copy": "Discover The Lex, where prime location and luxury living meet in Tacoma. Situated close to Union Station, these apartments offer modern studio, one-, and two-bedroom layouts complete with stylish quartz countertops and soft-close cabinetry.\n\nLiving close to Union Station means you're at the nexus of Tacoma's vibrant culture and history, with easy access to transportation, dining, and entertainment. After a day in the bustling city, retreat to the comfort of The Lex. Relax in our stunning sky lounge and enjoy panoramic views, making your living experience both convenient and serene. Experience the perfect balance of urban accessibility and elegant comfort at The Lex. Schedule a tour and redefine your lifestyle today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
      "featured_image_media": {
        "alt_text": "Modern apartment buildings with a view of the water and mountains.",
        "public_id": "019d0813-338c-72e2-89d1-036efec250bb",
        "storage_key": "property/6767906449164272/019d0813-338c-72e2-89d1-036efec250bb.webp",
        "width": 2600,
        "height": 1830
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Union Station Tacoma",
      "seo_description": "Find luxury and convenience at The Lex, offering apartments close to Union Station Tacoma. Enjoy modern living with easy access. Contact us!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4930"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9241077813"
    },
    {
      "ID": "custom_pay_rent_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MJNSMD33"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/b2a01cd4-856d-428d-953d-de3f485848cb/app.js?property=b2a01cd4-856d-428d-953d-de3f485848cb&propertyName=The+Lex&channelUuid=35d25c13-d6ed-11ec-a53a-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_id",
      "type": "STRING",
      "value": "40vlm62nple"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "6003821862"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/40vlm62nple"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "717-594-9593"
    },
    {
      "ID": "custom_seattle_income_limits_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im4zV3VkaDZKaVFVd1lqUlIvd2ZuT1E9PSIsInZhbHVlIjoieEtWcldxVThuOFlqMC9Ea2RPK2hBZz09IiwibWFjIjoiZTg0OGE2MjAxNGNjYzZhODU3ZDBiZjY5ZWI1ZDA1Nzk1ZmYzM2ZiYzNkOWVjOTMyNzQxMDQxYzE0NDVlZTU1MiJ9"
    },
    {
      "ID": "custom_pillar_properties_guarantee",
      "type": "STRING",
      "value": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple."
    },
    {
      "ID": "custom_seattle_income_qualified_blurb",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_pillar_properties_screening_criteria",
      "type": "STRING",
      "value": "https://multihubmedia.com/company/5767906449162415/019db50d-a8cb-763d-af04-d28a9e278494.pdf"
    },
    {
      "ID": "custom_pillar_properties_guarantee_disclaimer",
      "type": "STRING",
      "value": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "4930",
  "custom_repli_id": "9241077813",
  "custom_google_gtm_id": "GTM-MJNSMD33",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"https://webchat.omni.cafe/conversations/b2a01cd4-856d-428d-953d-de3f485848cb/app.js?property=b2a01cd4-856d-428d-953d-de3f485848cb&propertyName=The+Lex&channelUuid=35d25c13-d6ed-11ec-a53a-42010aa8d42b\" defer></script>",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_id": "40vlm62nple",
  "custom_hubspot_company_id": "6003821862",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/40vlm62nple",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "717-594-9593",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im4zV3VkaDZKaVFVd1lqUlIvd2ZuT1E9PSIsInZhbHVlIjoieEtWcldxVThuOFlqMC9Ea2RPK2hBZz09IiwibWFjIjoiZTg0OGE2MjAxNGNjYzZhODU3ZDBiZjY5ZWI1ZDA1Nzk1ZmYzM2ZiYzNkOWVjOTMyNzQxMDQxYzE0NDVlZTU1MiJ9",
  "custom_pillar_properties_guarantee": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple.",
  "custom_pillar_properties_screening_criteria": "https://multihubmedia.com/company/5767906449162415/019db50d-a8cb-763d-af04-d28a9e278494.pdf",
  "custom_pillar_properties_guarantee_disclaimer": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
};

export const generatedAt = '2026-10-23T17:56:58.276Z';
